import { useState, useRef, useEffect, useCallback, useMemo } from "react";

const LOGO_WHITE = "data:image/png;base64,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";
const LOGO_GOLD  = "data:image/png;base64,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";
const LOGO_ON_WHITE = "data:image/png;base64,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";



const API_URL = "https://d9gp4dwpjw4in.cloudfront.net";

// ── Cognito Config ──────────────────────────────────────────────────────────
const COGNITO = {
  region:   "us-east-2",
  poolId:   "us-east-2_behl3sU6w",
  clientId: "2vfe8cmjtrh3ro424mlkp1e9nt",
  endpoint: "https://cognito-idp.us-east-2.amazonaws.com/",
};

async function cognitoAuth(username, password) {
  const res = await fetch(COGNITO.endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-amz-json-1.1",
      "X-Amz-Target": "AWSCognitoIdentityProviderService.InitiateAuth",
    },
    body: JSON.stringify({
      AuthFlow: "USER_PASSWORD_AUTH",
      ClientId: COGNITO.clientId,
      AuthParameters: { USERNAME: username, PASSWORD: password },
    }),
  });
  return res.json();
}

async function cognitoForgotPassword(username) {
  const res = await fetch(COGNITO.endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-amz-json-1.1",
      "X-Amz-Target": "AWSCognitoIdentityProviderService.ForgotPassword",
    },
    body: JSON.stringify({
      ClientId: COGNITO.clientId,
      Username: username,
    }),
  });
  return res.json();
}

async function cognitoConfirmForgotPassword(username, code, newPassword) {
  const res = await fetch(COGNITO.endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-amz-json-1.1",
      "X-Amz-Target": "AWSCognitoIdentityProviderService.ConfirmForgotPassword",
    },
    body: JSON.stringify({
      ClientId: COGNITO.clientId,
      Username: username,
      ConfirmationCode: code,
      Password: newPassword,
    }),
  });
  return res.json();
}

async function cognitoNewPassword(username, newPassword, session, name) {
  const res = await fetch(COGNITO.endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-amz-json-1.1",
      "X-Amz-Target": "AWSCognitoIdentityProviderService.RespondToAuthChallenge",
    },
    body: JSON.stringify({
      ChallengeName: "NEW_PASSWORD_REQUIRED",
      ClientId: COGNITO.clientId,
      ChallengeResponses: {
        USERNAME: username,
        NEW_PASSWORD: newPassword,
        "userAttributes.website": "https://intelligence.starstandard.org",
        "userAttributes.name": name || username,
      },
      Session: session,
    }),
  });
  return res.json();
}

// ── Login Screen ────────────────────────────────────────────────────────────
function LoginScreen({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [stage, setStage] = useState("login");
  const [session, setSession] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState(null);
  const [resetCode, setResetCode] = useState("");
  const [resetPassword, setResetPassword] = useState("");
  const [resetConfirm, setResetConfirm] = useState("");
  const [panelContent, setPanelContent] = useState(null);

  useEffect(() => {
    fetch(`https://star-standard-content.s3.amazonaws.com/intelligence-panel.json?t=${Date.now()}`)
      .then(r => r.json()).then(setPanelContent).catch(() => setPanelContent(null));
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault(); setError(null); setLoading(true);
    try {
      const data = await cognitoAuth(email, password);
      if (data.ChallengeName === "NEW_PASSWORD_REQUIRED") { setSession(data.Session); setStage("newpassword"); }
      else if (data.AuthenticationResult) { const tok = data.AuthenticationResult.IdToken; localStorage.setItem("star_token", tok); localStorage.setItem("star_email", email); onLogin(tok, email); }
      else setError(data.message || data.__type || "Login failed");
    } catch { setError("Network error — please try again"); } finally { setLoading(false); }
  };

  const handleNewPassword = async (e) => {
    e.preventDefault(); setError(null);
    if (newPassword !== confirmPassword) { setError("Passwords don't match"); return; }
    setLoading(true);
    try {
      const data = await cognitoNewPassword(email, newPassword, session, fullName);
      if (data.AuthenticationResult) { const tok = data.AuthenticationResult.IdToken; localStorage.setItem("star_token", tok); localStorage.setItem("star_email", email); onLogin(tok, email); }
      else setError(data.message || data.__type || "Failed to set password");
    } catch { setError("Network error"); } finally { setLoading(false); }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault(); setError(null); setLoading(true);
    try {
      const data = await cognitoForgotPassword(email);
      if (data.__type) setError(data.message || data.__type);
      else { setSuccessMsg(`Reset code sent to ${data.CodeDeliveryDetails?.Destination || email}`); setStage("confirm"); }
    } catch { setError("Network error"); } finally { setLoading(false); }
  };

  const handleConfirmReset = async (e) => {
    e.preventDefault(); setError(null);
    if (resetPassword !== resetConfirm) { setError("Passwords don't match"); return; }
    setLoading(true);
    try {
      const data = await cognitoConfirmForgotPassword(email, resetCode, resetPassword);
      if (data.__type) setError(data.message || data.__type);
      else { setSuccessMsg("Password reset! Please sign in."); setStage("login"); }
    } catch { setError("Network error"); } finally { setLoading(false); }
  };

  const ACCENT = "#c9a84c";

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=JetBrains+Mono:wght@300;400;500&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Syne', sans-serif; }
        .login-wrap { min-height: 100vh; display: grid; grid-template-columns: 460px 1fr; }
        .login-left { background: #ffffff; padding: 56px 48px; display: flex; flex-direction: column; justify-content: center; min-height: 100vh; }
        .login-logo-text { font-size: 22px; font-weight: 800; font-style: italic; letter-spacing: -.02em; margin-bottom: 4px; }
        .login-logo-text span:first-child { color: #c9a84c; }
        .login-logo-text span:last-child { color: #1a1a2e; }
        .login-logo-sub { font-family: 'JetBrains Mono', monospace; font-size: 9px; letter-spacing: .16em; text-transform: uppercase; color: #9b98b0; margin-bottom: 40px; }
        .login-title { font-size: 24px; font-weight: 700; color: #1a1a2e; margin-bottom: 6px; }
        .login-subtitle { font-size: 14px; color: #6b6880; margin-bottom: 28px; line-height: 1.5; }
        .login-label { font-family: 'JetBrains Mono', monospace; font-size: 9px; letter-spacing: .12em; text-transform: uppercase; color: #6b6880; display: block; margin-bottom: 6px; }
        .login-input { width: 100%; background: #f8f7ff; border: 1.5px solid #e8e5f5; border-radius: 8px; padding: 12px 14px; color: #1a1a2e; font-family: 'Syne', sans-serif; font-size: 14px; outline: none; transition: border-color .2s; margin-bottom: 16px; }
        .login-input:focus { border-color: #c9a84c; }
        .login-input::placeholder { color: #c4c0d8; }
        .login-btn { width: 100%; padding: 13px; border-radius: 8px; border: none; background: #c9a84c; color: #fff; font-family: 'Syne', sans-serif; font-weight: 700; font-size: 15px; cursor: pointer; margin-top: 4px; transition: opacity .2s; }
        .login-btn:hover { opacity: .88; } .login-btn:disabled { opacity: .4; cursor: not-allowed; }
        .login-error { background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 10px 14px; color: #dc2626; font-size: 12px; margin-bottom: 16px; font-family: 'JetBrains Mono', monospace; }
        .login-success { background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 8px; padding: 10px 14px; color: #16a34a; font-size: 12px; margin-bottom: 16px; font-family: 'JetBrains Mono', monospace; }
        .login-divider { border: none; border-top: 1px solid #f0eeff; margin: 20px 0; }
        .login-link { background: none; border: none; color: #c9a84c; font-family: 'JetBrains Mono', monospace; font-size: 11px; cursor: pointer; text-decoration: underline; display: block; text-align: center; }
        .login-hint { font-size: 12px; color: #9b98b0; text-align: center; margin-top: 20px; font-family: 'JetBrains Mono', monospace; line-height: 1.6; }
        .login-right { background: #1a1f2e; padding: 56px 48px; display: flex; flex-direction: column; justify-content: center; position: relative; overflow: hidden; }
        .login-right::before { content: ''; position: absolute; top: -100px; right: -100px; width: 400px; height: 400px; background: radial-gradient(circle, rgba(201,168,76,.15) 0%, transparent 70%); pointer-events: none; }
        .login-right::after { content: ''; position: absolute; bottom: -80px; left: -60px; width: 300px; height: 300px; background: radial-gradient(circle, rgba(20,184,166,.1) 0%, transparent 70%); pointer-events: none; }
        .panel-hero { margin-bottom: 32px; position: relative; z-index: 1; }
        .panel-headline { font-size: 26px; font-weight: 800; color: #f0eeff; margin-bottom: 8px; line-height: 1.2; }
        .panel-tagline { font-size: 14px; color: #b8b5cc; line-height: 1.6; margin-bottom: 12px; }
        .panel-badge { display: inline-block; font-family: 'JetBrains Mono', monospace; font-size: 10px; letter-spacing: .08em; color: #e4c97e; background: rgba(201,168,76,.12); border: 1px solid rgba(201,168,76,.2); padding: 4px 12px; border-radius: 20px; }
        .panel-section { margin-bottom: 22px; position: relative; z-index: 1; }
        .panel-section-title { font-family: 'JetBrains Mono', monospace; font-size: 10px; letter-spacing: .12em; text-transform: uppercase; color: #e4c97e; margin-bottom: 10px; }
        .panel-divider { border: none; border-top: 1px solid #1e1e30; margin: 0 0 12px; }
        .panel-item { display: flex; align-items: flex-start; gap: 8px; margin-bottom: 7px; font-size: 13px; color: #c8c5dc; line-height: 1.5; }
        .panel-item::before { content: '·'; color: #e4c97e; flex-shrink: 0; font-weight: 700; }
        .panel-link { display: flex; align-items: center; gap: 6px; font-family: 'JetBrains Mono', monospace; font-size: 11px; color: #b8b5cc; text-decoration: none; margin-bottom: 6px; transition: color .15s; }
        .panel-link:hover { color: #e4c97e; }
        .panel-link::before { content: '→'; color: #e4c97e; font-weight: 700; }
        .skeleton { background: #1e1e30; border-radius: 4px; animation: pulse 1.5s infinite; }
        @keyframes pulse { 0%,100%{opacity:.4} 50%{opacity:.8} }
        @media (max-width: 768px) { .login-wrap { grid-template-columns: 1fr; } .login-right { display: none; } }
      `}</style>
      <div className="login-wrap">
        {/* LEFT — Login Form */}
        <div className="login-left">
          <div>
            <img src={LOGO_ON_WHITE} alt="STAR" style={{height:36,objectFit:"contain",marginBottom:4}} />
            <div className="login-logo-sub">Automotive Retail API Platform</div>
          </div>

          {stage === "login" && (<>
            <div className="login-title">Welcome back</div>
            <div className="login-subtitle">Sign in with your STAR member credentials.</div>
            {error && <div className="login-error">{error}</div>}
            {successMsg && <div className="login-success">{successMsg}</div>}
            <form onSubmit={handleLogin}>
              <label className="login-label">Email</label>
              <input className="login-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@starstandard.org" required />
              <label className="login-label">Password</label>
              <input className="login-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
              <button className="login-btn" type="submit" disabled={loading}>{loading ? "Signing in…" : "Sign In →"}</button>
            </form>
            <hr className="login-divider" />
            <button className="login-link" onClick={() => { setStage("forgot"); setError(null); setSuccessMsg(null); }}>Forgot password?</button>
            <div className="login-hint">Access is provided by your STAR administrator.<br/>Contact your admin if you need an account.</div>
            <div style={{marginTop:16,padding:"10px 14px",background:"rgba(201,168,76,.08)",border:"1px solid rgba(201,168,76,.2)",borderRadius:8,fontSize:13,color:"#1a1a2e",fontWeight:500,textAlign:"center",lineHeight:1.6}}>
              ⚠️ <strong style={{color:"#c9a84c"}}>Beta Version</strong> — This platform is under active development.<br/>
              AI-generated responses may contain errors. If in doubt, verify with official STAR documentation or contact the STAR team.
            </div>
          </>)}

          {stage === "newpassword" && (<>
            <div className="login-title">Set your password</div>
            <div className="login-subtitle">First sign in — set a permanent password.</div>
            {error && <div className="login-error">{error}</div>}
            <form onSubmit={handleNewPassword}>
              <label className="login-label">Your Name</label>
              <input className="login-input" type="text" value={fullName} onChange={e => setFullName(e.target.value)} placeholder="First Last" required />
              <label className="login-label">New Password</label>
              <input className="login-input" type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="Min 8 chars, upper+lower+number+symbol" required />
              <label className="login-label">Confirm Password</label>
              <input className="login-input" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Repeat password" required />
              <button className="login-btn" type="submit" disabled={loading}>{loading ? "Setting…" : "Set Password & Sign In →"}</button>
            </form>
          </>)}

          {stage === "forgot" && (<>
            <div className="login-title">Reset password</div>
            <div className="login-subtitle">Enter your email and we'll send a reset code.</div>
            {error && <div className="login-error">{error}</div>}
            <form onSubmit={handleForgotPassword}>
              <label className="login-label">Email</label>
              <input className="login-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@starstandard.org" required />
              <button className="login-btn" type="submit" disabled={loading}>{loading ? "Sending…" : "Send Reset Code →"}</button>
            </form>
            <hr className="login-divider" />
            <button className="login-link" onClick={() => { setStage("login"); setError(null); }}>← Back to sign in</button>
          </>)}

          {stage === "confirm" && (<>
            <div className="login-title">Enter reset code</div>
            <div className="login-subtitle">{successMsg || "Check your email for the reset code."}</div>
            {error && <div className="login-error">{error}</div>}
            <form onSubmit={handleConfirmReset}>
              <label className="login-label">Reset Code</label>
              <input className="login-input" type="text" value={resetCode} onChange={e => setResetCode(e.target.value)} placeholder="6-digit code" required />
              <label className="login-label">New Password</label>
              <input className="login-input" type="password" value={resetPassword} onChange={e => setResetPassword(e.target.value)} placeholder="New password" required />
              <label className="login-label">Confirm Password</label>
              <input className="login-input" type="password" value={resetConfirm} onChange={e => setResetConfirm(e.target.value)} placeholder="Repeat password" required />
              <button className="login-btn" type="submit" disabled={loading}>{loading ? "Resetting…" : "Reset Password →"}</button>
            </form>
          </>)}
        </div>

        {/* RIGHT — Dynamic Marketing Panel */}
        <div className="login-right">
          {!panelContent ? (
            <>
              <div style={{marginBottom:32}}>
                <div className="skeleton" style={{height:28,width:"70%",marginBottom:10}} />
                <div className="skeleton" style={{height:14,width:"90%",marginBottom:6}} />
                <div className="skeleton" style={{height:14,width:"55%",marginBottom:12}} />
                <div className="skeleton" style={{height:22,width:"60%",borderRadius:20}} />
              </div>
              {[1,2,3].map(i => (
                <div key={i} style={{marginBottom:22}}>
                  <div className="skeleton" style={{height:10,width:"40%",marginBottom:10}} />
                  <div style={{borderTop:"1px solid #1e1e30",marginBottom:10}} />
                  <div className="skeleton" style={{height:10,width:"88%",marginBottom:6}} />
                  <div className="skeleton" style={{height:10,width:"72%",marginBottom:6}} />
                  <div className="skeleton" style={{height:10,width:"80%"}} />
                </div>
              ))}
            </>
          ) : (<>
            <div className="panel-hero">
              <img src={LOGO_GOLD} alt="STAR" style={{height:32,objectFit:"contain",marginBottom:12}} />
              <div className="panel-headline">{panelContent.hero?.headline}</div>
              <div className="panel-tagline">{panelContent.hero?.tagline}</div>
              {panelContent.hero?.badge && <div className="panel-badge">{panelContent.hero.badge}</div>}
            </div>
            {(panelContent.sections || []).map((section, i) => (
              <div key={i} className="panel-section">
                <div className="panel-section-title">{section.title}</div>
                <div className="panel-divider" />
                {(section.items || []).map((item, j) => (
                  <div key={j} className="panel-item">{item}</div>
                ))}
                {(section.links || []).map((link, j) => (
                  <a key={j} href={link.url} className="panel-link" target="_blank" rel="noopener noreferrer">{link.label}</a>
                ))}
              </div>
            ))}
          </>)}
        </div>
      </div>
    </>
  );
}

// ── Audiences ──────────────────────────────────────────────────────────────
const AUDIENCES = {
  executive: {
    label: "Executive", icon: "◈", color: "#c084fc",
    prompt: "You are explaining STAR automotive API capabilities to a C-suite executive. Be concise, focus on business value, avoid technical jargon. Keep answers to 3-4 short paragraphs maximum.",
    hint: "Ask about business value, capabilities, or strategy…",
    tooltip: "C-suite view — concise answers focused on business value, ROI, and capabilities. No technical jargon.",
  },
  analyst: {
    label: "Business Analyst", icon: "◉", color: "#38bdf8",
    prompt: "You are explaining STAR automotive APIs to a business analyst. Use business terminology, explain data flows in plain English.",
    hint: "Ask about data models, workflows, or field meanings…",
    tooltip: "Analyst view — data flows, field meanings, and business rules explained in plain English.",
  },
  architect: {
    label: "Architect", icon: "◎", color: "#34d399",
    prompt: "You are explaining STAR automotive APIs to a solution architect. Be precise about API boundaries, contracts, schema references.",
    hint: "Ask about API design, integration patterns, or schemas…",
    tooltip: "Architect view — API boundaries, integration patterns, schema references, and system design.",
  },
  developer: {
    label: "Developer", icon: "◆", color: "#fbbf24",
    prompt: "You are explaining STAR automotive APIs to a software developer. Be precise and technical. Show exact field names, types, operationIds, and JSON examples.",
    hint: "Ask about APIs, endpoints, schemas, payloads, or examples…",
    tooltip: "Developer view — technical details with exact field names, operationIds, types, and JSON examples.",
  },
};

const QUICK_PROMPTS = {
  executive: [
    { label: "MPI business value", query: "What does the multi point inspection API do for our business?", domain: null },
    { label: "Available APIs", query: "What APIs are available in the STAR platform?", domain: null },
    { label: "Repair order workflow", query: "How does the repair order API support our service workflow?", domain: null },
  ],
  analyst: [
    { label: "MPI workflow", query: "Explain the multi point inspection workflow from start to finish", domain: "multi_point_inspection" },
    { label: "Customer data in MPI", query: "What customer data does the MPI API capture?", domain: "multi_point_inspection" },
    { label: "Repair order + labor ops", query: "How does the repair order connect to labor operations?", domain: "repair_order" },
  ],
  architect: [
    { label: "Bounded contexts", query: "What are the STAR APIs and how do they relate?", domain: null },
    { label: "MPI domain model", query: "Show me the API model for multi point inspection", domain: "multi_point_inspection" },
    { label: "repair_order ↔ party", query: "What are the integration points between repair_order and party?", domain: null },
  ],
  developer: [
    { label: "Create MPI", query: "How do I create a multi point inspection? Show me the payload", domain: "multi_point_inspection" },
    { label: "List MPI operations", query: "List all operations in the multi point inspection API", domain: "multi_point_inspection" },
    { label: "Repair order examples", query: "Show me all examples of a repair order", domain: "repair_order" },
  ],
};

// ── Markdown renderer ──────────────────────────────────────────────────────
function renderMarkdown(text) {
  if (!text) return "";
  // Fix escaped pipes and trailing backslashes in table cells
  text = text.replace(/\\\|/g, '&#124;');  // escaped pipes → HTML entity
  text = text.replace(/\s*\\\s*\n/g, '<br/>');  // trailing backslash newlines → line breaks
  text = text.replace(/\s*\\\s*(?=\S)/g, ', '); // mid-line backslashes → comma separator
  // Fix tables first - convert markdown tables to HTML
  text = text.replace(/((^\|.+\|$\n?)+)/gm, (tableBlock) => {
    const lines = tableBlock.trim().split("\n").filter(l => l.trim());
    const rows = lines.filter(l => !/^\|[\s|:-]+\|$/.test(l.trim()));
    if (rows.length === 0) return tableBlock;
    let html = '<table>';
    rows.forEach((row, i) => {
      const cells = row.trim().slice(1,-1).split("|").map(c => c.trim());
      const tag = i === 0 ? 'th' : 'td';
      html += '<tr>' + cells.map(c => `<${tag}>${c}</${tag}>`).join('') + '</tr>';
    });
    html += '</table>';
    return html;
  });
  return text
    .replace(/```(\w*)\n([\s\S]*?)```/g, (_, lang, code) => {
      const escaped = code.replace(/</g, "&lt;").replace(/>/g, "&gt;");
      return `<div class="code-block-wrap"><button class="code-copy-btn" onclick="(function(btn){var pre=btn.nextElementSibling;var text=pre.querySelector('code').innerText;navigator.clipboard.writeText(text).then(function(){btn.textContent='✓ Copied';setTimeout(function(){btn.textContent='📋 Copy';},1500);});})(this)">📋 Copy</button><pre class="code-block"><code class="lang-${lang}">${escaped}</code></pre></div>`;
    })
    .replace(/`([^`]+)`/g, '<code class="inline-code">$1</code>')
    .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
    .replace(/\*([^*]+)\*/g, "<em>$1</em>")
    .replace(/^### (.+)$/gm, "<h3>$1</h3>")
    .replace(/^## (.+)$/gm, "<h2>$1</h2>")
    .replace(/^# (.+)$/gm, "<h1>$1</h1>")
    .replace(/^\|(.+)\|$/gm, (row) => {
      const trimmed = row.trim();
      if (/^[\s|:=-]+$/.test(trimmed)) return "__SEPARATOR__";
      const cells = trimmed.slice(1,-1).split("|").map(c => `<td>${c.trim()}</td>`).join("");
      return `<tr>${cells}</tr>`;
    })
    .replace(/<tr>[^]*?__SEPARATOR__[^]*?(?=<tr>|$)/gs, m => m.replace("__SEPARATOR__",""))
    .replace(/(__SEPARATOR__)/g, "")
    .replace(/(<tr>[\s\S]*?<\/tr>\s*)+/g, m => `<table><thead></thead><tbody>${m}</tbody></table>`)
    .replace(/^- (.+)$/gm, "<li>$1</li>")
    .replace(/(<li>.*<\/li>\n?)+/gs, m => `<ul>${m}</ul>`)
    .replace(/^> (.+)$/gm, "<blockquote>$1</blockquote>")
    .replace(/\n\n/g, "</p><p>")
    .replace(/^(?!<[huptbcu])/gm, "")
    .replace(/<p><\/p>/g, "");
}

// ── Lookup Tab Component ────────────────────────────────────────────────────
const QUERY_TYPES = [
  "API inventory",
  "Examples — list",
  "Examples — view full",
  "Operations — list",
  "Operations — by method",
  "Schemas — list",
  "Schemas — view full",
  "Properties — list",
  "Text search",
  "Operation detail",
  "Corpus stats",
];

const METHODS = ["GET", "POST", "PUT", "PATCH", "DELETE"];
const CHUNK_TYPES = ["operation","business_explain","schema","operation_list","domain_summary","example","property","relationship"];

// ── Tooltip Component ─────────────────────────────────────────────────────
function Tooltip({ text, children }) {
  const [show, setShow] = useState(false);
  const [coords, setCoords] = useState({ x: 0, y: 0, align: "center" });
  const ref = useRef(null);
  const TIP_WIDTH = 260;

  const handleEnter = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const vw = window.innerWidth;
      // Determine horizontal alignment to keep tooltip in viewport
      let x = cx;
      let align = "center";
      if (cx - TIP_WIDTH / 2 < 12) {
        x = rect.left; align = "left";   // too close to left edge
      } else if (cx + TIP_WIDTH / 2 > vw - 12) {
        x = rect.right; align = "right"; // too close to right edge
      }
      setCoords({ x, y: rect.bottom + 8, align });
    }
    setShow(true);
  };

  const transformMap = { center: "translateX(-50%)", left: "translateX(0)", right: "translateX(-100%)" };

  return (
    <div ref={ref} style={{position:"relative",display:"inline-flex"}}
      onMouseEnter={handleEnter}
      onMouseLeave={() => setShow(false)}>
      {children}
      {show && (
        <div style={{
          position:"fixed",
          left: coords.x,
          top: coords.y,
          transform: transformMap[coords.align],
          background:"#1a1f2e",
          color:"#e4e4f0",
          border:"1px solid rgba(201,168,76,.4)",
          borderRadius:8,
          padding:"10px 14px",
          fontSize:12,
          fontFamily:"Arial, sans-serif",
          lineHeight:1.6,
          whiteSpace:"normal",
          width: TIP_WIDTH,
          zIndex:99999,
          pointerEvents:"none",
          boxShadow:"0 8px 24px rgba(0,0,0,.5)",
          wordBreak:"break-word",
        }}>{text}</div>
      )}
    </div>
  );
}


// ── Download Helper ───────────────────────────────────────────────────────
function DownloadButton({ getText, baseName, label = "⬇ Download", style = {}, extraFormats = [] }) {
  const [open, setOpen] = useState(false);

  const download = (format) => {
    setOpen(false);
    // Check for custom handler
    const custom = extraFormats.find(f => f.format === format);
    if (custom) { custom.handler(); return; }

    const text = getText();
    if (!text) return;
    let content, mime, ext;
    if (format === "txt") {
      content = text.replace(/#{1,6}\s+/g, '').replace(/\*\*([^*]+)\*\*/g, '$1')
        .replace(/\*([^*]+)\*/g, '$1').replace(/`([^`]+)`/g, '$1')
        .replace(/\|/g, ' ').replace(/\n{3,}/g, '\n\n');
      mime = "text/plain"; ext = "txt";
    } else {
      content = text; mime = "text/markdown"; ext = "md";
    }
    const blob = new Blob([content], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `${baseName}.${ext}`; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div style={{position:"relative",display:"inline-block"}}>
      <div style={{display:"flex",gap:0,...style}}>
        <button onClick={() => download("md")}
          style={{fontFamily:"var(--mono)",fontSize:10,letterSpacing:".06em",
            background:"transparent",border:"1px solid rgba(201,168,76,.3)",
            borderRight:"none",borderRadius:"4px 0 0 4px",
            color:"#e4c97e",padding:"4px 10px",cursor:"pointer",transition:"all .2s"}}
          onMouseOver={e=>e.currentTarget.style.background="rgba(201,168,76,.12)"}
          onMouseOut={e=>e.currentTarget.style.background="transparent"}>
          {label}
        </button>
        <button onClick={(e) => { e.stopPropagation(); setOpen(o => !o); }}
          style={{fontFamily:"var(--mono)",fontSize:10,
            background: open ? "rgba(201,168,76,.12)" : "transparent",
            border:"1px solid rgba(201,168,76,.3)",
            borderRadius:"0 4px 4px 0",
            color:"#e4c97e",padding:"4px 8px",cursor:"pointer",transition:"all .2s"}}
          onMouseOver={e=>e.currentTarget.style.background="rgba(201,168,76,.12)"}
          onMouseOut={e=>{ if(!open) e.currentTarget.style.background="transparent"; }}>
          ▾
        </button>
      </div>
      {open && (
        <>
          {/* Click outside to close */}
          <div style={{position:"fixed",inset:0,zIndex:999}} onClick={() => setOpen(false)} />
          <div style={{position:"absolute",top:"100%",right:0,zIndex:1000,
            background:"var(--bg2)",border:"1px solid rgba(201,168,76,.4)",
            borderRadius:6,overflow:"hidden",marginTop:4,minWidth:160,
            boxShadow:"0 4px 16px rgba(0,0,0,.4)"}}>
            {[["md","⬇ Markdown (.md)"],["txt","⬇ Plain text (.txt)"],
              ...extraFormats.map(f => [f.format, `⬇ ${f.label}`])
            ].map(([fmt, lbl]) => (
              <div key={fmt} onClick={() => { setOpen(false); download(fmt); }}
                style={{padding:"9px 16px",cursor:"pointer",fontFamily:"var(--mono)",
                  fontSize:11,color:"var(--text)",transition:"background .15s",
                  borderBottom:"1px solid var(--border)"}}
                onMouseOver={e=>e.currentTarget.style.background="rgba(201,168,76,.12)"}
                onMouseOut={e=>e.currentTarget.style.background="transparent"}>
                {lbl}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}


function LookupTab({ domains, apiUrl, authHeaders, version }) {
  const [queryType, setQueryType] = useState("API inventory");
  const [domain, setDomain] = useState("");
  const [method, setMethod] = useState("GET");
  const [schema, setSchema] = useState("");
  const [exampleFile, setExampleFile] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchDomain, setSearchDomain] = useState("");
  const [searchType, setSearchType] = useState("");
  const [result, setResult] = useState(null);
  const [subList, setSubList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [elapsed, setElapsed] = useState(null);
  const [navStack, setNavStack] = useState([]); // breadcrumb history

  const pushNav = (label) => setNavStack(prev => [...prev,
    { queryType, domain, schema, exampleFile, result, subList, label }]);

  const popNav = () => {
    if (navStack.length === 0) return;
    const prev = navStack[navStack.length - 1];
    setQueryType(prev.queryType); setDomain(prev.domain);
    setSchema(prev.schema); setExampleFile(prev.exampleFile);
    setResult(prev.result); setSubList(prev.subList || []);
    setNavStack(navStack.slice(0, -1));
  };

  const drillTo = (label, newQueryType, newDomain, newSchema, newExample) => {
    pushNav(label);
    if (newQueryType) setQueryType(newQueryType);
    if (newDomain !== undefined) setDomain(newDomain);
    if (newSchema !== undefined) setSchema(newSchema);
    if (newExample !== undefined) setExampleFile(newExample);
    setResult(null);
  };

  const needsAPI = !["API inventory","Corpus stats","Text search"].includes(queryType);

  // When domain/queryType changes, load sub-lists for schema/example selects
  useEffect(() => {
    setSubList([]);
    setSchema("");
    setExampleFile("");
    if (!domain) return;
    if (queryType === "Schemas — view full") {
      fetch(`${apiUrl}/lookup/schemas?domain=${encodeURIComponent(domain)}&version=${version || ""}`, { headers: authHeaders })
        .then(r => r.json()).then(d => setSubList((d.results || []).map(s => s.name))).catch(() => {});
    } else if (queryType === "Examples — view full") {
      fetch(`${apiUrl}/lookup/examples?domain=${encodeURIComponent(domain)}&version=${version || ""}`, { headers: authHeaders })
        .then(r => r.json()).then(d => setSubList((d.results || []).map(e => e.filename))).catch(() => {});
    }
  }, [domain, queryType]);

  const run = async (overrides = {}) => {
    setLoading(true); setError(null); setResult(null); setElapsed(null);
    const t0 = Date.now();
    // Use overrides for immediate drilldown (bypasses async state)
    const qType = overrides.queryType || queryType;
    const qDomain = overrides.domain !== undefined ? overrides.domain : domain;
    const qSchema = overrides.schema !== undefined ? overrides.schema : schema;
    const qExample = overrides.exampleFile !== undefined ? overrides.exampleFile : exampleFile;
    const qVersion = overrides.version !== undefined ? overrides.version : version;
    try {
      let data = null;

      if (qType === "API inventory") {
        const r = await fetch(`${apiUrl}/domains?version=${qVersion || ""}`, { headers: authHeaders });
        data = { _type: "domains", ...(await r.json()) };

      } else if (qType === "Corpus stats") {
        const r = await fetch(`${apiUrl}/stats`, { headers: authHeaders });
        data = { _type: "stats", ...(await r.json()) };

      } else if (qType === "Operations — list" || qType === "Operations — by method") {
        const p = new URLSearchParams({ domain: qDomain });
        if (qType === "Operations — by method") p.set("method", method);
        const r = await fetch(`${apiUrl}/lookup/operations?${p}&version=${qVersion || ""}`, { headers: authHeaders });
        data = { _type: "operations", ...(await r.json()) };

      } else if (qType === "Schemas — list") {
        const r = await fetch(`${apiUrl}/lookup/schemas?domain=${encodeURIComponent(qDomain)}&version=${qVersion || ""}`, { headers: authHeaders });
        data = { _type: "schemas", ...(await r.json()) };

      } else if (qType === "Schemas — view full") {
        const p = new URLSearchParams({ domain: qDomain, schema: qSchema });
        const r = await fetch(`${apiUrl}/lookup/schemas/detail?${p}&version=${qVersion || ""}`, { headers: authHeaders });
        data = { _type: "schema_detail", ...(await r.json()) };

      } else if (qType === "Examples — list") {
        const r = await fetch(`${apiUrl}/lookup/examples?domain=${encodeURIComponent(qDomain)}&version=${qVersion || ""}`, { headers: authHeaders });
        data = { _type: "examples_list", ...(await r.json()) };

      } else if (qType === "Examples — view full") {
        const p = new URLSearchParams({ domain: qDomain, filename: qExample });
        const r = await fetch(`${apiUrl}/lookup/examples/detail?${p}&version=${qVersion || ""}`, { headers: authHeaders });
        data = { _type: "example_detail", ...(await r.json()) };

      } else if (qType === "Properties — list") {
        const p = new URLSearchParams({ domain: qDomain });
        if (qSchema) p.set("schema", qSchema);
        const r = await fetch(`${apiUrl}/lookup/properties?${p}&version=${qVersion || ""}`, { headers: authHeaders });
        data = { _type: "properties", ...(await r.json()) };

      } else if (qType === "Text search") {
        const p = new URLSearchParams({ q: searchTerm, limit: 30 });
        if (searchDomain) p.set("domain", searchDomain);
        if (searchType) p.set("chunk_type", searchType);
        const r = await fetch(`${apiUrl}/lookup/text-search?${p}&version=${qVersion || ""}`, { headers: authHeaders });
        data = { _type: "text_search", ...(await r.json()) };

      } else if (qType === "Operation detail") {
        // Use actual version — main YAMLs are uploaded to yamls/main/
        const yamlVersion = (!qVersion || qVersion === "latest") ? "v1.2.0" : qVersion;
        if (!qSchema) {
          throw new Error("No operation selected — please click an operation from the list");
        }
        const p = new URLSearchParams({ version: yamlVersion, domain: qDomain, operation_id: qSchema });
        const r = await fetch(`${apiUrl}/yaml/operation?${p}`, { headers: authHeaders });
        if (!r.ok) {
          const err = await r.json().catch(() => ({}));
          throw new Error(err.detail || `Operation not found: ${qSchema}`);
        }
        data = { _type: "operation_detail", ...(await r.json()) };
      }

      setElapsed(Date.now() - t0);
      setResult(data);
      // Log lookup event
      fetch(`${apiUrl}/usage/event`, {
        method: "POST",
        headers: authHeaders,
        body: JSON.stringify({
          event_type: "lookup", tool: "intelligence",
          version: qVersion, domain: qDomain,
          meta: { query_type: qType }
        }),
      }).catch(() => {});
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const renderResult = () => {
    if (!result) return null;
    const T = result._type;

    if (T === "domains") {  // API inventory
      return (
        <table className="result-table">
          <thead><tr><th>API</th><th>Ops</th><th>Schemas</th><th>Examples</th><th>Props</th><th>Total</th></tr></thead>
          <tbody>
            {(result.domains || []).map((d, i) => (
              <tr key={i}>
                <td>
                  <span
                    style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--teal)",cursor:"pointer",textDecoration:"underline",textDecorationStyle:"dotted"}}
                    title={`Browse ${d.domain} operations`}
                    onClick={() => { drillTo("API inventory", "Operations — list", d.domain, "", ""); run({ queryType: "Operations — list", domain: d.domain }); }}
                  >{d.domain}</span>
                </td>
                <td>
                  <span style={{cursor:"pointer",color:"var(--amber)",fontFamily:"var(--mono)",fontSize:11}} title="View operations"
                    onClick={() => { setDomain(d.domain); setQueryType("Operations — list"); }}>
                    {d.operations}
                  </span>
                </td>
                <td>
                  <span style={{cursor:"pointer",color:"var(--purple)",fontFamily:"var(--mono)",fontSize:11}} title="View schemas"
                    onClick={() => { drillTo("API inventory", "Schemas — list", d.domain, "", ""); run({ queryType: "Schemas — list", domain: d.domain }); }}>
                    {d.schemas}
                  </span>
                </td>
                <td>
                  <span style={{cursor:"pointer",color:"var(--green2)",fontFamily:"var(--mono)",fontSize:11}} title="View examples"
                    onClick={() => { drillTo("API inventory", "Examples — list", d.domain, "", ""); run({ queryType: "Examples — list", domain: d.domain }); }}>
                    {d.examples}
                  </span>
                </td>
                <td>{d.properties}</td>
                <td style={{color:"var(--muted)"}}>{d.total?.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

    if (T === "stats") {
      const byType = result.by_type || {};
      const entries = Array.isArray(byType) ? byType : Object.entries(byType).map(([type,count])=>({type,count}));
      return (
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
          <div>
            <div className="result-section-title">By Type</div>
            <table className="result-table">
              <thead><tr><th>Type</th><th>Count</th></tr></thead>
              <tbody>
                {entries.map((row, i) => (
                  <tr key={i}><td>{row.type}</td><td>{row.count?.toLocaleString()}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
          <div>
            <div className="result-section-title">Summary</div>
            <table className="result-table">
              <thead><tr><th>Metric</th><th>Value</th></tr></thead>
              <tbody>
                <tr><td>Total chunks</td><td>{result.total_chunks?.toLocaleString() || result.total?.toLocaleString()}</td></tr>
                <tr><td>Embedded</td><td>{result.embedded?.toLocaleString()}</td></tr>
                <tr><td>Total APIs</td><td>{result.total_domains}</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    if (T === "operations") {
      return (
        <table className="result-table">
          <thead><tr><th>Method</th><th>Path</th><th>Operation ID</th><th>Summary</th></tr></thead>
          <tbody>
            {(result.results || []).map((op, i) => (
              <tr key={i} style={{cursor:"pointer"}}
                onClick={() => {
                  // Push current state to nav stack WITHOUT triggering state change
                  const navEntry = { queryType, domain, schema, exampleFile, result, subList,
                    label: `${domain} operations` };
                  setNavStack(prev => [...prev, navEntry]);
                  // Set state for breadcrumb display
                  setQueryType("Operation detail");
                  setSchema(op.operation_id);
                  // Run immediately with explicit values — no async state dependency
                  run({ queryType: "Operation detail", domain, schema: op.operation_id });
                }}
                title={`View detail for ${op.operation_id}`}>
                <td><span style={{fontFamily:"var(--mono)",fontSize:10,fontWeight:700,
                  color: op.method==="GET"?"var(--teal)":op.method==="POST"?"#4ade80":op.method==="DELETE"?"#f87171":op.method==="PATCH"?"#a78bfa":"var(--amber)"}}>{op.method}</span></td>
                <td style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--text)"}}>{op.path}</td>
                <td style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--amber)",
                  textDecoration:"underline",textDecorationStyle:"dotted"}}>{op.operation_id}</td>
                <td style={{fontSize:12,color:"var(--muted)"}}>{op.summary}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

    if (T === "schemas") {
      return (
        <table className="result-table">
          <thead><tr><th>Schema</th><th>Type</th><th>Description</th></tr></thead>
          <tbody>
            {(result.results || []).map((s, i) => (
              <tr key={i}>
                <td>
                  <span
                    style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--amber)",cursor:"pointer",
                      textDecoration:"underline",textDecorationStyle:"dotted"}}
                    title={`View ${s.name} fields`}
                    onClick={() => {
                      const navEntry = { queryType, domain, schema, exampleFile, result, subList, label: `${domain} schemas` };
                      setNavStack(prev => [...prev, navEntry]);
                      setQueryType("Schemas — view full");
                      setSchema(s.name);
                      run({ queryType: "Schemas — view full", domain, schema: s.name });
                    }}
                  >{s.name}</span>
                </td>
                <td style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--muted)"}}>{s.type}</td>
                <td style={{fontSize:12}}>{s.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

    if (T === "operation_detail") {
      const op = result;
      const methodColor = op.method==="GET"?"var(--teal)":op.method==="POST"?"#4ade80":op.method==="DELETE"?"#f87171":op.method==="PATCH"?"#a78bfa":"var(--amber)";
      return (
        <div>
          {/* Header */}
          <div style={{background:"var(--bg3)",borderRadius:10,padding:"16px 20px",marginBottom:20,
            border:"1px solid var(--border)"}}>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:8}}>
              <span style={{fontFamily:"var(--mono)",fontSize:14,fontWeight:800,color:methodColor,
                padding:"4px 12px",borderRadius:6,background:`${methodColor}20`}}>{op.method}</span>
              <span style={{fontFamily:"var(--mono)",fontSize:13,color:"var(--text)"}}>{op.path}</span>
            </div>
            <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--amber)",marginBottom:4}}>{op.operation_id}</div>
            {op.summary && <div style={{fontSize:14,color:"var(--muted)",marginBottom:4}}>{op.summary}</div>}
            {op.description && <div style={{fontSize:13,color:"var(--dim)",fontStyle:"italic"}}>{op.description}</div>}
            {op.tags?.length > 0 && (
              <div style={{marginTop:8,display:"flex",gap:6,flexWrap:"wrap"}}>
                {op.tags.map((t,i) => <span key={i} style={{fontFamily:"var(--mono)",fontSize:9,
                  color:"var(--muted)",padding:"2px 8px",borderRadius:10,border:"1px solid var(--border2)"}}>{t}</span>)}
              </div>
            )}
          </div>

          {/* Parameters */}
          {op.parameters?.length > 0 && (
            <div style={{marginBottom:20}}>
              <div className="result-section-title" style={{marginBottom:8}}>Parameters</div>
              <table className="result-table">
                <thead><tr><th>Name</th><th>In</th><th>Type</th><th>Required</th><th>Description</th></tr></thead>
                <tbody>
                  {op.parameters.map((p, i) => (
                    <tr key={i}>
                      <td style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--teal)"}}>{p.name}</td>
                      <td style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--muted)"}}>{p.in}</td>
                      <td style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--amber)"}}>{p.type}</td>
                      <td>{p.required ? <span style={{color:"#4ade80"}}>✓</span> : <span style={{color:"var(--dim)"}}>—</span>}</td>
                      <td style={{fontSize:12}}>{p.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Request Body */}
          {op.request_body && (
            <div style={{marginBottom:20}}>
              <div className="result-section-title" style={{marginBottom:8}}>Request Body {op.request_body.required && <span style={{color:"#f87171",fontSize:10,marginLeft:6}}>required</span>}</div>
              <div style={{background:"var(--bg3)",borderRadius:8,padding:"12px 16px",
                border:"1px solid var(--border)",display:"flex",alignItems:"center",gap:12}}>
                <span style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--muted)"}}>{op.request_body.content_type}</span>
                {op.request_body.schema && (
                  <span
                    style={{fontFamily:"var(--mono)",fontSize:12,color:"var(--amber)",
                      textDecoration:"underline",textDecorationStyle:"dotted",cursor:"pointer"}}
                    title={`View ${op.request_body.schema} schema`}
                    onClick={() => {
                      const navEntry = { queryType, domain, schema, exampleFile, result, subList, label: `${op.operation_id} request` };
                      setNavStack(prev => [...prev, navEntry]);
                      setQueryType("Schemas — view full");
                      setSchema(op.request_body.schema);
                      run({ queryType: "Schemas — view full", domain, schema: op.request_body.schema });
                    }}
                  >{op.request_body.schema} →</span>
                )}
              </div>
            </div>
          )}

          {/* Responses */}
          {op.responses?.length > 0 && (
            <div style={{marginBottom:20}}>
              <div className="result-section-title" style={{marginBottom:8}}>Responses</div>
              <table className="result-table">
                <thead><tr><th>Code</th><th>Description</th><th>Schema</th></tr></thead>
                <tbody>
                  {op.responses.map((r, i) => (
                    <tr key={i}>
                      <td style={{fontFamily:"var(--mono)",fontSize:12,fontWeight:700,
                        color: r.code.startsWith("2")?"#4ade80":r.code.startsWith("4")?"#f87171":"var(--amber)"}}>{r.code}</td>
                      <td style={{fontSize:12}}>{r.description}</td>
                      <td>
                        {r.schema ? (
                          <span
                            style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--amber)",
                              textDecoration:"underline",textDecorationStyle:"dotted",cursor:"pointer"}}
                            title={`View ${r.schema} schema`}
                            onClick={() => {
                              const navEntry = { queryType, domain, schema, exampleFile, result, subList, label: `${op.operation_id} responses` };
                              setNavStack(prev => [...prev, navEntry]);
                              setQueryType("Schemas — view full");
                              setSchema(r.schema);
                              run({ queryType: "Schemas — view full", domain, schema: r.schema });
                            }}
                          >{r.schema} →</span>
                        ) : <span style={{color:"var(--dim)"}}>—</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      );
    }

    if (T === "schema_detail") {
      const props = result.properties || [];
      return (
        <div>
          <div style={{display:"flex",gap:24,padding:"12px 0",marginBottom:8}}>
            <div><div className="result-section-title">API</div><div style={{color:"var(--teal)",fontFamily:"var(--mono)",fontSize:12}}>{domain}</div></div>
            <div><div className="result-section-title">Properties</div><div style={{color:"var(--purple)",fontFamily:"var(--mono)",fontSize:12}}>{props.length}</div></div>
          </div>
          <table className="result-table">
            <thead><tr><th>Property</th><th>Type</th><th>Req</th><th>Description</th></tr></thead>
            <tbody>
              {props.map((p, i) => (
                <tr key={i}>
                  <td style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--teal)"}}>{p.name}</td>
                  <td style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--amber)"}}>
                    {p.type && (p.type.startsWith("$ref:") || p.type.startsWith("array[")) ? (
                      <span
                        style={{cursor:"pointer",textDecoration:"underline",textDecorationStyle:"dotted"}}
                        title={`Drill into ${p.type.replace("$ref:","").replace("array[","").replace("]","")}`}
                        onClick={() => {
                          const refName = p.type.replace("$ref:","").replace("array[","").replace("]","").trim();
                          const navEntry = { queryType, domain, schema, exampleFile, result, subList, label: `${schema} fields` };
                          setNavStack(prev => [...prev, navEntry]);
                          setQueryType("Schemas — view full");
                          setSchema(refName);
                          run({ queryType: "Schemas — view full", domain, schema: refName });
                        }}
                      >{p.type}</span>
                    ) : p.type}
                  </td>
                  <td>{p.required ? <span style={{color:"#4ade80"}}>✓</span> : <span style={{color:"var(--dim)"}}>—</span>}</td>
                  <td style={{fontSize:12}}>{p.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {result.schema?.text && (
            <details style={{marginTop:12}}>
              <summary style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--muted)",cursor:"pointer",letterSpacing:".08em"}}>FULL SCHEMA TEXT</summary>
              <pre className="result-json" style={{marginTop:8}}>{result.schema.text}</pre>
            </details>
          )}
        </div>
      );
    }

    if (T === "examples_list") {
      return (
        <table className="result-table">
          <thead><tr><th>File</th><th>Type</th><th>Operation</th><th>Size</th></tr></thead>
          <tbody>
            {(result.results || []).map((e, i) => (
              <tr key={i}>
                <td>
                  <span
                    style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--amber)",
                      cursor:"pointer",textDecoration:"underline",textDecorationStyle:"dotted"}}
                    title={`View ${e.filename}`}
                    onClick={() => {
                      const navEntry = { queryType, domain, schema, exampleFile, result, subList, label: `${domain} examples` };
                      setNavStack(prev => [...prev, navEntry]);
                      setQueryType("Examples — view full");
                      setExampleFile(e.filename);
                      run({ queryType: "Examples — view full", domain, exampleFile: e.filename });
                    }}
                  >{e.filename}</span>
                </td>
                <td style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--muted)"}}>{e.example_type}</td>
                <td style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--teal)"}}>{e.operation}</td>
                <td>{e.file_size?.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

    if (T === "example_detail") {
      const meta = result.metadata || {};
      return (
        <div>
          <div style={{display:"flex",gap:24,padding:"12px 0",marginBottom:8}}>
            <div><div className="result-section-title">Type</div><div style={{color:"var(--amber)",fontFamily:"var(--mono)",fontSize:12}}>{meta.example_type || "—"}</div></div>
            <div><div className="result-section-title">Operation</div><div style={{color:"var(--teal)",fontFamily:"var(--mono)",fontSize:12}}>{meta.operation || "—"}</div></div>
            <div><div className="result-section-title">Size</div><div style={{color:"var(--muted)",fontFamily:"var(--mono)",fontSize:12}}>{meta.file_size?.toLocaleString() || "—"} chars</div></div>
          </div>
          <pre className="result-json">{result.content || result.text}</pre>
        </div>
      );
    }

    if (T === "properties") {
      return (
        <table className="result-table">
          <thead><tr><th>Schema</th><th>Property</th><th>Type</th><th>Req</th><th>Description</th></tr></thead>
          <tbody>
            {(result.results || []).map((p, i) => (
              <tr key={i}>
                <td style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--purple)"}}>{p.schema_name}</td>
                <td style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--teal)"}}>{p.name}</td>
                <td style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--amber)"}}>{p.type}</td>
                <td>{p.required ? <span style={{color:"#4ade80"}}>✓</span> : <span style={{color:"var(--dim)"}}>—</span>}</td>
                <td style={{fontSize:12}}>{p.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

    if (T === "text_search") {
      return (
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {(result.results || []).map((r, i) => (
            <details key={i} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:6,padding:"8px 12px"}}>
              <summary style={{cursor:"pointer",fontFamily:"var(--mono)",fontSize:10,color:"var(--muted)"}}>
                <span style={{color:"var(--purple)"}}>[{r.type}]</span>{" "}
                <span style={{color:"var(--teal)"}}>{r.domain}</span>{" — "}
                <span style={{color:"var(--text)"}}>{String(r.text_preview || "").substring(0,80)}</span>
              </summary>
              <pre className="result-json" style={{marginTop:8,fontSize:11}}>{JSON.stringify(r.metadata, null, 2)}</pre>
            </details>
          ))}
        </div>
      );
    }

    return <pre className="result-json">{JSON.stringify(result, null, 2)}</pre>;
  };

  const count = result?.results?.length ?? result?.domains?.length ?? null;

  return (
    <div className="lookup-container">
      <div className="lookup-header">
        <div style={{fontFamily:"var(--mono)",fontSize:13,fontWeight:700,
          letterSpacing:".06em",textTransform:"uppercase",color:"var(--text)",marginBottom:4}}>
          Quick Lookup
        </div>
        <p>Direct API queries — instant, zero token cost · Click an API or schema name to drill down
          <Tooltip text="Quick Lookup queries the database directly — no AI tokens used. Results are instant and free." position="right">
            <span style={{cursor:"help",color:"var(--amber)",fontSize:12,marginLeft:8,
              border:"1px solid rgba(201,168,76,.3)",borderRadius:"50%",
              width:16,height:16,display:"inline-flex",alignItems:"center",
              justifyContent:"center",fontWeight:700}}>?</span>
          </Tooltip>
        </p>
      </div>

      <div className="lookup-controls" style={{flexWrap:"wrap"}}>
        {/* Query type */}
        <select className="lookup-select" value={queryType} onChange={e => { setQueryType(e.target.value); setResult(null); setSubList([]); }}>
          {QUERY_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
        </select>

        {/* API selector */}
        {needsAPI && (
          <select className="lookup-select" value={domain} onChange={e => setDomain(e.target.value)}>
            <option value="">— API —</option>
            {domains.map(d => <option key={d.domain} value={d.domain}>{d.domain}</option>)}
          </select>
        )}

        {/* Method selector for Operations — by method */}
        {queryType === "Operations — by method" && (
          <select className="lookup-select" value={method} onChange={e => setMethod(e.target.value)} style={{maxWidth:100}}>
            {METHODS.map(m => <option key={m}>{m}</option>)}
          </select>
        )}

        {/* Schema name input for Schemas — view full / Properties */}
        {queryType === "Schemas — view full" && domain && (
          <select className="lookup-select" value={schema} onChange={e => setSchema(e.target.value)}>
            <option value="">— schema —</option>
            {subList.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        )}

        {queryType === "Properties — list" && (
          <input className="lookup-input" value={schema} onChange={e => setSchema(e.target.value)}
            placeholder="Schema name (opt)" style={{maxWidth:200}} />
        )}

        {/* Example file selector */}
        {queryType === "Examples — view full" && domain && (
          <select className="lookup-select" value={exampleFile} onChange={e => setExampleFile(e.target.value)}>
            <option value="">— file —</option>
            {subList.map(f => <option key={f} value={f}>{f}</option>)}
          </select>
        )}

        {/* Text search controls */}
        {queryType === "Text search" && (
          <>
            <input className="lookup-input" value={searchTerm} onChange={e => setSearchTerm(e.target.value)}
              placeholder="Search term…" onKeyDown={e => e.key === "Enter" && run()} />
            <select className="lookup-select" value={searchDomain} onChange={e => setSearchDomain(e.target.value)}>
              <option value="">(all APIs)</option>
              {domains.map(d => <option key={d.domain} value={d.domain}>{d.domain}</option>)}
            </select>
            <select className="lookup-select" value={searchType} onChange={e => setSearchType(e.target.value)} style={{maxWidth:150}}>
              <option value="">(all types)</option>
              {CHUNK_TYPES.map(t => <option key={t}>{t}</option>)}
            </select>
          </>
        )}

        <button className="run-btn" onClick={run} disabled={loading}>
          {loading ? "Running…" : "▶ Run"}
        </button>
      </div>

      {error && <div style={{color:"#f87171",fontFamily:"var(--mono)",fontSize:11,padding:"8px 0"}}>Error: {error}</div>}

      {/* Breadcrumb navigation */}
      {navStack.length > 0 && (
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:10,
          fontFamily:"var(--mono)",fontSize:10,color:"var(--dim)",flexWrap:"wrap"}}>
          <button onClick={() => { setNavStack([]); setResult(null); setQueryType("API inventory"); setDomain(""); setSchema(""); }}
            style={{background:"transparent",border:"none",cursor:"pointer",fontFamily:"var(--mono)",
              fontSize:10,color:"var(--dim)",padding:0,transition:"color .2s"}}
            onMouseOver={e=>e.target.style.color="var(--amber)"}
            onMouseOut={e=>e.target.style.color="var(--dim)"}
          >⌂ Home</button>
          {navStack.map((n, i) => (
            <span key={i} style={{display:"flex",alignItems:"center",gap:6}}>
              <span style={{opacity:.4}}>›</span>
              <button onClick={() => {
                  const prev = navStack[i];
                  setQueryType(prev.queryType); setDomain(prev.domain);
                  setSchema(prev.schema); setExampleFile(prev.exampleFile);
                  setResult(prev.result); setSubList(prev.subList || []);
                  setNavStack(navStack.slice(0, i));
                }}
                style={{background:"transparent",border:"none",cursor:"pointer",fontFamily:"var(--mono)",
                  fontSize:10,color:"var(--dim)",padding:0,transition:"color .2s"}}
                onMouseOver={e=>e.target.style.color="var(--amber)"}
                onMouseOut={e=>e.target.style.color="var(--dim)"}
              >{n.label}</button>
            </span>
          ))}
          <span style={{opacity:.4}}>›</span>
          <span style={{color:"var(--text)"}}>{queryType}{domain ? ` · ${domain}` : ""}</span>
        </div>
      )}

      {result && (
        <div className="result-box">
          <div className="result-header">
            <span>{queryType}{domain ? ` · API: ${domain}` : ""}</span>
            <div style={{display:"flex",gap:12,alignItems:"center"}}>
              {navStack.length > 0 && (
                <button onClick={popNav}
                  style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--amber)",
                    background:"transparent",border:"1px solid rgba(201,168,76,.3)",
                    borderRadius:4,padding:"2px 8px",cursor:"pointer",transition:"all .2s"}}
                  onMouseOver={e=>{e.currentTarget.style.background="rgba(201,168,76,.1)";}}
                  onMouseOut={e=>{e.currentTarget.style.background="transparent";}}
                >← Back</button>
              )}
              {count !== null && <span className="result-count">{count} results</span>}
              {elapsed && <span style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--dim)"}}>{elapsed}ms</span>}
            </div>
          </div>
          {renderResult()}
        </div>
      )}
    </div>
  );
}


// ── Compare Versions Tab ──────────────────────────────────────────────────
// ── Report Generators ─────────────────────────────────────────────────────────
function generateFullCompareReport(result, drillCache = {}) {
  const ts = new Date().toLocaleString();
  const lines = [];
  const a = s => lines.push(s);

  a(`# STAR API Version Comparison Report`);
  a(`**From:** ${result.versionA}  →  **To:** ${result.versionB}`);
  if (result.domain) a(`**Domain Filter:** ${result.domain}`);
  a(`**Generated:** ${ts}`);
  a(``);
  a(`---`);
  a(``);

  // Summary
  a(`## Summary`);
  a(`| Metric | Value |`);
  a(`|--------|-------|`);
  a(`| New APIs | ${(result.newDomains||[]).length} |`);
  a(`| Removed APIs | ${(result.removedDomains||[]).length} |`);
  a(`| Changed APIs | ${(result.changedDomains||[]).length} |`);
  a(`| Unchanged APIs | ${(result.unchangedDomains||[]).length} |`);
  a(``);

  // New domains
  if ((result.newDomains||[]).length > 0) {
    a(`## ✅ New APIs in ${result.versionB}`);
    a(`| API | Operations | Schemas |`);
    a(`|-----|------------|---------|`);
    (result.newDomains||[]).forEach(d => a(`| \`${d.domain}\` | ${d.operations} | ${d.schemas} |`));
    a(``);
  }

  // Removed domains
  if ((result.removedDomains||[]).length > 0) {
    a(`## ❌ Removed APIs from ${result.versionA}`);
    a(`| API | Operations | Schemas |`);
    a(`|-----|------------|---------|`);
    (result.removedDomains||[]).forEach(d => a(`| \`${d.domain}\` | ${d.operations} | ${d.schemas} |`));
    a(``);
  }

  // Changed domains
  if ((result.changedDomains||[]).length > 0) {
    a(`## 📝 Changed APIs`);
    a(`| API | Ops (${result.versionA}→${result.versionB}) | Δ Ops | Schemas (${result.versionA}→${result.versionB}) | Δ Schemas |`);
    a(`|-----|------|-------|---------|-----------|`);
    (result.changedDomains||[]).forEach(d => {
      const dOps = (d.operations||0)-(d.prevOps||0);
      const dSch = (d.schemas||0)-(d.prevSchemas||0);
      a(`| \`${d.domain}\` | ${d.prevOps}→${d.operations} | ${dOps>0?"+":""}${dOps} | ${d.prevSchemas}→${d.schemas} | ${dSch>0?"+":""}${dSch} |`);
    });
    a(``);
  }

  // Claude analysis
  // Post-process Claude output — replace domain→API in visible text
  const aiAnalysis = (result.answer || "")
    .replace(/\bdomains\b/g, "APIs")
    .replace(/\bDomains\b/g, "APIs")
    .replace(/\bdomain\b/g, "API")
    .replace(/\bDomain\b/g, "API")
    .replace(/bounded contexts/g, "APIs")
    .replace(/bounded context/g, "API")
    .replace(/Bounded Contexts/g, "APIs")
    .replace(/Bounded Context/g, "API");
  a(`## AI Analysis`);
  a(aiAnalysis);
  a(``);

  // Drill-down details
  const drilledDomains = Object.keys(drillCache);
  if (drilledDomains.length > 0) {
    a(`---`);
    a(`## Operation-Level Detail`);
    a(`> *Detail for ${drilledDomains.length} API(s) inspected*`);
    a(``);
    drilledDomains.forEach(domainName => {
      const data = drillCache[domainName];
      a(`### ${domainName}`);
      a(`**${result.versionA}:** ${data.opsA.length} operations → **${result.versionB}:** ${data.opsB.length} operations`);
      a(``);
      if (data.newOps.length > 0) {
        a(`#### ✅ New Operations (${data.newOps.length})`);
        a(`| Method | Path | Operation ID |`);
        a(`|--------|------|-------------|`);
        data.newOps.forEach(op => a(`| \`${op.method?.toUpperCase()}\` | \`${op.path}\` | \`${op.operation_id||""}\` |`));
        a(``);
      }
      if (data.removedOps.length > 0) {
        a(`#### ❌ Removed Operations (${data.removedOps.length})`);
        a(`| Method | Path | Operation ID |`);
        a(`|--------|------|-------------|`);
        data.removedOps.forEach(op => a(`| \`${op.method?.toUpperCase()}\` | \`${op.path}\` | \`${op.operation_id||""}\` |`));
        a(``);
      }
      if (data.keptOps.length > 0) {
        a(`#### ✓ Unchanged Operations (${data.keptOps.length})`);
        a(`| Method | Path | Operation ID |`);
        a(`|--------|------|-------------|`);
        data.keptOps.forEach(op => a(`| \`${op.method?.toUpperCase()}\` | \`${op.path}\` | \`${op.operation_id||""}\` |`));
        a(``);
      }
    });
  }

  a(`---`);
  a(`*Report generated by STAR Intelligence Platform*`);
  return lines.join("\n");
}

function downloadCompareDocx(result, drillCache = {}) {
  // Generate HTML that Word can open — rich formatting, tables, headings
  const md = generateFullCompareReport(result, drillCache);

  // Convert markdown to simple HTML for Word
  let html = md
    .replace(/^# (.+)$/gm, '<h1>$1</h1>')
    .replace(/^## (.+)$/gm, '<h2>$1</h2>')
    .replace(/^### (.+)$/gm, '<h3>$1</h3>')
    .replace(/^#### (.+)$/gm, '<h4>$1</h4>')
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/\*([^*]+)\*/g, '<em>$1</em>')
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    .replace(/^---$/gm, '<hr/>')
    .replace(/^> (.+)$/gm, '<blockquote>$1</blockquote>');

  // Convert markdown tables to HTML tables
  html = html.replace(/(\|.+\|\n)+/g, (table) => {
    const rows = table.trim().split("\n");
    let htable = '<table border="1" cellpadding="4" style="border-collapse:collapse;width:100%"><thead>';
    rows.forEach((row, i) => {
      if (row.match(/^\|[-| ]+\|$/)) return; // skip separator
      const cells = row.split("|").filter((_, idx, arr) => idx > 0 && idx < arr.length - 1);
      const tag = i === 0 ? "th" : "td";
      if (i === 1) htable += '</thead><tbody>';
      htable += `<tr>${cells.map(c => `<${tag} style="padding:4px 8px">${c.trim()}</${tag}>`).join("")}</tr>`;
    });
    htable += '</tbody></table>';
    return htable;
  });

  // Wrap remaining lines in paragraphs
  html = html.split("\n").map(line => {
    if (line.match(/^<[h1-6|table|hr|blockquote]/)) return line;
    if (!line.trim()) return '<p>&nbsp;</p>';
    return `<p>${line}</p>`;
  }).join("\n");

  const docHtml = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:w="urn:schemas-microsoft-com:office:word"
          xmlns="http://www.w3.org/TR/REC-html40">
    <head>
      <meta charset="UTF-8">
      <title>STAR API Comparison ${result.versionA} vs ${result.versionB}</title>
      <!--[if gte mso 9]><xml><w:WordDocument><w:View>Print</w:View></w:WordDocument></xml><![endif]-->
      <style>
        body { font-family: Calibri, sans-serif; font-size: 11pt; margin: 1in; }
        h1 { font-size: 18pt; color: #1e3a5f; border-bottom: 2pt solid #e4c97e; padding-bottom: 6pt; }
        h2 { font-size: 14pt; color: #1e3a5f; margin-top: 16pt; }
        h3 { font-size: 12pt; color: #2d6a4f; margin-top: 12pt; }
        h4 { font-size: 11pt; color: #6d4c41; }
        table { border-collapse: collapse; width: 100%; margin: 8pt 0; font-size: 9pt; }
        th { background: #1e3a5f; color: white; padding: 4pt 8pt; text-align: left; }
        td { padding: 3pt 8pt; border: 0.5pt solid #ccc; }
        tr:nth-child(even) td { background: #f5f5f5; }
        code { font-family: Courier New; font-size: 9pt; background: #f0f0f0; padding: 1pt 3pt; }
        hr { border: 0.5pt solid #ccc; margin: 12pt 0; }
        blockquote { color: #666; border-left: 3pt solid #e4c97e; padding-left: 8pt; margin: 8pt 0; }
      </style>
    </head>
    <body>${html}</body>
    </html>`;

  const blob = new Blob([docHtml], { type: "application/msword" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `star_compare_${result.versionA}_vs_${result.versionB}.doc`;
  a.click();
  URL.revokeObjectURL(url);
}

// ── Domain Drill-Down Component ───────────────────────────────────────────────
function DomainDrillDown({ result, authHeaders, API_URL, drillCache = {}, setDrillCache = () => {} }) {
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [drillData, setDrillData]           = useState(null);
  const [drillLoading, setDrillLoading]     = useState(false);
  const [drillError, setDrillError]         = useState(null);
  const [activeTab, setActiveTab]           = useState("operations"); // operations | schemas

  // All APIs that changed OR are new/removed
  const allInteresting = [
    ...(result.changedDomains || []).map(d => ({ ...d, kind: "changed" })),
    ...(result.newDomains     || []).map(d => ({ ...d, kind: "new" })),
    ...(result.removedDomains || []).map(d => ({ ...d, kind: "removed" })),
  ].sort((a, b) => {
    // Sort by magnitude of change
    const deltaA = Math.abs((a.operations || 0) - (a.prevOps || 0)) + Math.abs((a.schemas || 0) - (a.prevSchemas || 0));
    const deltaB = Math.abs((b.operations || 0) - (b.prevOps || 0)) + Math.abs((b.schemas || 0) - (b.prevSchemas || 0));
    return deltaB - deltaA;
  });

  const drillInto = async (domain) => {
    setSelectedDomain(domain);
    setDrillError(null);
    setDrillLoading(true);
    // Return cached data if available
    if (drillCache[domain.domain]) {
      setDrillData(drillCache[domain.domain]);
      setDrillLoading(false);
      return;
    }
    setDrillData(null);
    try {
      const [resA, resB] = await Promise.all([
        fetch(`${API_URL}/lookup/operations?domain=${domain.domain}&limit=300&version=${result.versionA}`, { headers: authHeaders }),
        fetch(`${API_URL}/lookup/operations?domain=${domain.domain}&limit=300&version=${result.versionB}`, { headers: authHeaders }),
      ]);
      const [dataA, dataB] = await Promise.all([resA.json(), resB.json()]);
      const opsA = dataA.operations || dataA.results || [];
      const opsB = dataB.operations || dataB.results || [];
      const opsAMap = new Map(opsA.map(o => [o.operation_id || `${o.method}:${o.path}`, o]));
      const opsBMap = new Map(opsB.map(o => [o.operation_id || `${o.method}:${o.path}`, o]));
      const newOps     = opsB.filter(o => !opsAMap.has(o.operation_id || `${o.method}:${o.path}`));
      const removedOps = opsA.filter(o => !opsBMap.has(o.operation_id || `${o.method}:${o.path}`));
      const keptOps    = opsB.filter(o =>  opsAMap.has(o.operation_id || `${o.method}:${o.path}`));
      const data = { opsA, opsB, newOps, removedOps, keptOps };
      setDrillData(data);
      // Cache for report generation
      setDrillCache(prev => ({ ...prev, [domain.domain]: data }));
    } catch(e) {
      setDrillError("Failed to load operation details: " + e.message);
    } finally {
      setDrillLoading(false);
    }
  };

  const methodColor = (m) => ({
    GET:"#60a5fa", POST:"#34d399", PUT:"#f59e0b",
    PATCH:"#a78bfa", DELETE:"#f87171"
  })[m?.toUpperCase()] || "#9ca3af";

  const OpRow = ({ op, badge }) => (
    <div style={{display:"flex",alignItems:"center",gap:10,padding:"7px 12px",
      borderRadius:6,background:"var(--bg3)",marginBottom:4}}>
      {badge && <span style={{fontSize:10,fontWeight:700}}>{badge}</span>}
      <span style={{fontFamily:"var(--mono)",fontSize:10,fontWeight:700,
        color:methodColor(op.method),minWidth:48}}>{op.method?.toUpperCase()}</span>
      <span style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--text)",flex:1,
        overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{op.path}</span>
      <span style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--dim)",
        overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:200}}>{op.operation_id}</span>
    </div>
  );

  return (
    <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:12,
      overflow:"hidden",marginBottom:16}}>
      {/* Header */}
      <div style={{background:"var(--bg3)",padding:"12px 20px",borderBottom:"1px solid var(--border)",
        display:"flex",alignItems:"center",gap:10}}>
        <span style={{fontFamily:"var(--mono)",fontSize:10,fontWeight:700,
          letterSpacing:".1em",textTransform:"uppercase",color:"var(--amber)"}}>
          🔍 API Drill-Down
        </span>
        <span style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--dim)"}}>
          Click an API to see operation-level changes
        </span>
      </div>

      {/* API pills */}
      <div style={{padding:"14px 20px",borderBottom:"1px solid var(--border)",
        display:"flex",flexWrap:"wrap",gap:8}}>
        {allInteresting.map((d, i) => {
          const delta = (d.operations || 0) - (d.prevOps || 0);
          const isSelected = selectedDomain?.domain === d.domain;
          const kindColor = d.kind === "new" ? "#34d399" : d.kind === "removed" ? "#f87171" : "#f59e0b";
          const kindEmoji = d.kind === "new" ? "✅" : d.kind === "removed" ? "❌" : "📝";
          return (
            <button key={i} onClick={() => drillInto(d)}
              style={{
                padding:"6px 14px",borderRadius:20,cursor:"pointer",
                fontFamily:"var(--mono)",fontSize:10,transition:"all .2s",
                border: isSelected ? `1px solid ${kindColor}` : "1px solid var(--border2)",
                background: isSelected ? `${kindColor}22` : "transparent",
                color: isSelected ? kindColor : "var(--text)",
              }}
              onMouseOver={e=>{if(!isSelected){e.currentTarget.style.borderColor=kindColor;e.currentTarget.style.color=kindColor;}}}
              onMouseOut={e=>{if(!isSelected){e.currentTarget.style.borderColor="var(--border2)";e.currentTarget.style.color="var(--text)";}}}
            >
              {kindEmoji} {d.domain}
              {d.kind === "changed" && delta !== 0 && (
                <span style={{marginLeft:6,fontSize:9,opacity:.8}}>
                  {delta > 0 ? "+" : ""}{delta} ops
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* Drill results */}
      {drillLoading && (
        <div style={{padding:24,textAlign:"center",fontFamily:"var(--mono)",
          fontSize:11,color:"var(--dim)"}}>
          Loading operation diff for {selectedDomain?.domain}...
        </div>
      )}
      {drillError && (
        <div style={{padding:24,color:"#f87171",fontFamily:"var(--mono)",fontSize:11}}>{drillError}</div>
      )}
      {drillData && selectedDomain && !drillLoading && (
        <div style={{padding:20}}>
          {/* API header */}
          <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
            <span style={{fontFamily:"var(--mono)",fontSize:13,fontWeight:700,color:"var(--text)"}}>
              {selectedDomain.domain}
            </span>
            <span style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--dim)"}}>
              {result.versionA}: {drillData.opsA.length} ops → {result.versionB}: {drillData.opsB.length} ops
            </span>
            {/* Tab switcher */}
            <div style={{marginLeft:"auto",display:"flex",gap:4}}>
              {["operations"].map(t => (
                <button key={t} onClick={() => setActiveTab(t)}
                  style={{padding:"4px 12px",borderRadius:6,fontFamily:"var(--mono)",fontSize:9,
                    cursor:"pointer",transition:"all .15s",
                    background: activeTab===t ? "var(--amber)" : "transparent",
                    color: activeTab===t ? "#000" : "var(--dim)",
                    border: activeTab===t ? "1px solid var(--amber)" : "1px solid var(--border2)",
                  }}>
                  {t}
                </button>
              ))}
            </div>
          </div>

          {/* Stats row */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:16}}>
            {[
              { label:"✅ New", count: drillData.newOps.length, color:"#34d399" },
              { label:"❌ Removed", count: drillData.removedOps.length, color:"#f87171" },
              { label:"✓ Kept", count: drillData.keptOps.length, color:"var(--dim)" },
            ].map((s, i) => (
              <div key={i} style={{background:"var(--bg3)",borderRadius:8,padding:"12px 16px",textAlign:"center"}}>
                <div style={{fontFamily:"var(--mono)",fontSize:20,fontWeight:700,color:s.color}}>{s.count}</div>
                <div style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--dim)",marginTop:2}}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* New operations */}
          {drillData.newOps.length > 0 && (
            <div style={{marginBottom:16}}>
              <div style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".1em",
                textTransform:"uppercase",color:"#34d399",marginBottom:8}}>
                ✅ New in {result.versionB} ({drillData.newOps.length})
              </div>
              <div style={{maxHeight:280,overflowY:"auto"}}>
                {drillData.newOps.map((op, i) => <OpRow key={i} op={op} />)}
              </div>
            </div>
          )}

          {/* Removed operations */}
          {drillData.removedOps.length > 0 && (
            <div style={{marginBottom:16}}>
              <div style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".1em",
                textTransform:"uppercase",color:"#f87171",marginBottom:8}}>
                ❌ Removed from {result.versionA} ({drillData.removedOps.length})
              </div>
              <div style={{maxHeight:280,overflowY:"auto"}}>
                {drillData.removedOps.map((op, i) => <OpRow key={i} op={op} />)}
              </div>
            </div>
          )}

          {/* Kept operations (collapsed) */}
          {drillData.keptOps.length > 0 && (
            <details>
              <summary style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".1em",
                textTransform:"uppercase",color:"var(--dim)",cursor:"pointer",marginBottom:8}}>
                ✓ Unchanged operations ({drillData.keptOps.length}) — click to expand
              </summary>
              <div style={{maxHeight:280,overflowY:"auto",marginTop:8}}>
                {drillData.keptOps.map((op, i) => <OpRow key={i} op={op} />)}
              </div>
            </details>
          )}
        </div>
      )}

      {!selectedDomain && !drillLoading && (
        <div style={{padding:20,textAlign:"center",fontFamily:"var(--mono)",
          fontSize:11,color:"var(--dim)"}}>
          Select an API above to drill into its operation-level changes
        </div>
      )}
    </div>
  );
}

function CompareTab({ versions, domains, apiUrl, authHeaders }) {
  const [versionA, setVersionA] = useState("");
  const [versionB, setVersionB] = useState("");
  const [domain, setDomain] = useState("");
  const [topic, setTopic] = useState("");
  const [comparing, setComparing] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [followUp, setFollowUp] = useState("");
  const [history, setHistory] = useState([]);
  const [drillCache, setDrillCache] = useState({}); // domain → {newOps, removedOps, keptOps}
  const historyEndRef = useRef(null);

  useEffect(() => {
    if (versions.length >= 2) {
      setVersionA(versions[1].version);
      setVersionB(versions[0].version);
    } else if (versions.length === 1) {
      setVersionA(versions[0].version);
      setVersionB(versions[0].version);
    }
  }, [versions]);

  useEffect(() => {
    historyEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [history]);

  const QUICK_TOPICS = [
    { label: "All changes", query: "What are all the differences between these two versions? List new operations, removed operations, new schemas, removed schemas, and changed fields." },
    { label: "New operations", query: "What new API operations were added? List each new path, method, and operationId." },
    { label: "Schema changes", query: "What schemas changed between versions? What fields were added, removed, or modified?" },
    { label: "Breaking changes", query: "Are there any breaking changes? Look for removed operations, renamed fields, changed required fields, or modified response structures." },
    { label: "New APIs", query: "Were any entirely new API domains or bounded contexts added?" },
    { label: "Enum changes", query: "What enum values were added, removed, or changed between versions?" },
  ];

  const compare = async (queryOverride, isDrillDeeper = false) => {
    const q = queryOverride || topic;
    if (!q.trim()) { setError("Please enter a comparison topic or select a quick comparison"); return; }
    if (!versionA || !versionB) { setError("Please select two versions to compare"); return; }
    if (versionA === versionB) { setError("Please select two different versions"); return; }
    setComparing(true); if (!isDrillDeeper) { setResult(null); } setError(null);

    try {
      const chunkCounts = { "v1.0.0": 18139, "v1.1.0": 27683, "v1.2.0": 28128, "main": 38761 };
      const countA = chunkCounts[versionA] || "unknown";
      const countB = chunkCounts[versionB] || "unknown";

      // ── Fetch FULL domain inventory from /stats/domains for both versions ──
      // This gives ALL 83 domains, not just the RAG top-k subset
      const [statsA, statsB] = await Promise.all([
        fetch(`${apiUrl}/stats/domains?version=${versionA}`, { headers: authHeaders }),
        fetch(`${apiUrl}/stats/domains?version=${versionB}`, { headers: authHeaders }),
      ]);
      if (statsA.status === 401 || statsB.status === 401) { setError("Session expired — please sign out and sign in again."); return; }
      const [sdA, sdB] = await Promise.all([statsA.json(), statsB.json()]);

      // Build markdown tables from domain stats
      const domainTable = (sd) => {
        if (!sd?.domains?.length) return "No API data available";
        const rows = sd.domains
          .filter(d => domain ? d.domain === domain : true)
          .map(d => `| ${d.domain} | ${d.operations} | ${d.schemas} |`)
          .join("\n");
        return `| API | Operations | Schemas |\n|--------|------------|--------|\n${rows}`;
      };

      const inventoryA = domainTable(sdA);
      const inventoryB = domainTable(sdB);

      // ── Compute domain diff in JS — no guessing by Claude ────────────────
      const domainsA = new Map((sdA?.domains || []).map(d => [d.domain, d]));
      const domainsB = new Map((sdB?.domains || []).map(d => [d.domain, d]));

      const newDomains     = [...domainsB.values()].filter(d => !domainsA.has(d.domain));
      const removedDomains = [...domainsA.values()].filter(d => !domainsB.has(d.domain));
      const changedDomains = [...domainsB.values()].filter(d => {
        const a = domainsA.get(d.domain);
        return a && (a.operations !== d.operations || a.schemas !== d.schemas);
      }).map(d => ({ ...d, prevOps: domainsA.get(d.domain).operations, prevSchemas: domainsA.get(d.domain).schemas }));
      const unchangedDomains = [...domainsB.values()].filter(d => {
        const a = domainsA.get(d.domain);
        return a && a.operations === d.operations && a.schemas === d.schemas;
      });

      const newTable = newDomains.length ? newDomains.map(d => `| ✅ ${d.domain} | ${d.operations} | ${d.schemas} |`).join("\n") : "_None_";
      const removedTable = removedDomains.length ? removedDomains.map(d => `| ❌ ${d.domain} | ${d.operations} | ${d.schemas} |`).join("\n") : "_None_";
      const changedTable = changedDomains.length ? changedDomains.map(d =>
        `| 📝 ${d.domain} | ${d.prevOps}→${d.operations} (${d.operations-d.prevOps>0?"+":""}${d.operations-d.prevOps}) | ${d.prevSchemas}→${d.schemas} (${d.schemas-d.prevSchemas>0?"+":""}${d.schemas-d.prevSchemas}) |`
      ).join("\n") : "_None_";

      // ── Send to Claude for synthesis ──────────────────────────────────────
      const synthesisPrompt = `COMPARISON TASK: ${q}

You have COMPLETE domain inventories from two STAR API versions.
The diff below was computed mathematically — it is 100% accurate.

== SUMMARY ==
${versionA}: ${sdA?.domains?.length || "?"} domains, ${countA} chunks
${versionB}: ${sdB?.domains?.length || "?"} domains, ${countB} chunks
New domains: ${newDomains.length} | Removed: ${removedDomains.length} | Changed: ${changedDomains.length} | Unchanged: ${unchangedDomains.length}

== ✅ NEW APIS IN ${versionB} (${newDomains.length}) ==
| API | Operations | Schemas |
|-----|------------|---------|
${newTable}

== ❌ REMOVED FROM ${versionA} (${removedDomains.length}) ==
| API | Operations | Schemas |
|-----|------------|---------|
${removedTable}

== 📝 CHANGED APIS (${changedDomains.length}) ==
| API | Operations (prev→new) | Schemas (prev→new) |
|--------|-----------------------|--------------------|
${changedTable}

INSTRUCTIONS:
- Use the diff above AS-IS — do not recompute or second-guess it
- Provide analysis and insights about WHAT the changes mean architecturally
- Highlight the most significant changes
- Do NOT add caveats about incomplete data — this is the complete picture`;

      const synthesisRes = await fetch(apiUrl + "/query", {
        method: "POST", headers: authHeaders,
        body: JSON.stringify({
          query: synthesisPrompt,
          top_k: 5,
          domain: domain || null,
          version: versionB,
          model: "claude-sonnet-4-6",
        })
      });

      if (synthesisRes.status === 401) { setError("Session expired — please sign out and sign in again."); return; }
      const synthesis = await synthesisRes.json();
      const answer = synthesis.answer || synthesis.text || synthesis.detail ||
        `## ${versionA}\n\n${inventoryA}\n\n---\n\n## ${versionB}\n\n${inventoryB}`;
      const newResult = {
        answer, versionA, versionB, domain, question: q,
        chunksA: sdA?.domains?.length || 0,
        chunksB: sdB?.domains?.length || 0,
        timestamp: new Date().toLocaleTimeString(),
        // Store computed diff for drill-down
        newDomains, removedDomains, changedDomains, unchangedDomains,
      };
      setResult(newResult);
      setHistory(prev => [...prev, newResult]);
      fetch(`${apiUrl}/usage/event`, {
        method: "POST", headers: authHeaders,
        body: JSON.stringify({
          event_type: "compare", tool: "intelligence",
          meta: { version_a: versionA, version_b: versionB, domain: domain || null }
        }),
      }).catch(() => {});
    } catch (e) {
      setError("Comparison failed: " + e.message);
    } finally {
      setComparing(false);
    }
  };

  return (
    <div style={{flex:1, overflowY:"auto", padding:"28px 32px", background:"var(--bg)"}}>
      <div style={{marginBottom:24}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:6}}>
          <div style={{fontFamily:"var(--mono)",fontSize:13,fontWeight:700,
            letterSpacing:".06em",textTransform:"uppercase",color:"var(--text)",marginBottom:4}}>
            Compare Versions
          </div>
          {history.length > 0 && (
            <button
              onClick={() => { setHistory([]); setResult(null); setError(null); setTopic(""); setFollowUp(""); }}
              style={{
                display:"flex",alignItems:"center",gap:6,
                padding:"7px 16px",borderRadius:7,
                border:"1px solid rgba(239,68,68,.3)",
                background:"rgba(239,68,68,.06)",
                color:"#f87171",fontFamily:"var(--mono)",
                fontSize:10,letterSpacing:".08em",
                cursor:"pointer",transition:"all .2s",
              }}
              onMouseOver={e=>{e.currentTarget.style.background="rgba(239,68,68,.14)";e.currentTarget.style.borderColor="#ef4444";}}
              onMouseOut={e=>{e.currentTarget.style.background="rgba(239,68,68,.06)";e.currentTarget.style.borderColor="rgba(239,68,68,.3)";}}
            >
              ✦ New Conversation
            </button>
          )}
        </div>
        <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)"}}>Query two STAR versions simultaneously — get an AI-generated diff</div>
      </div>

      <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:12,padding:24,marginBottom:24}}>
        {/* Version selectors */}
        <div style={{display:"grid",gridTemplateColumns:"1fr auto 1fr",gap:16,alignItems:"end",marginBottom:20}}>
          <div>
            <div style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".12em",textTransform:"uppercase",color:"var(--muted)",marginBottom:6}}>Version A (older)</div>
            <select value={versionA} onChange={e => setVersionA(e.target.value)}
              style={{width:"100%",background:"var(--bg3)",border:"1px solid var(--border2)",borderRadius:8,padding:"10px 14px",color:"var(--text)",fontFamily:"var(--mono)",fontSize:12,outline:"none",cursor:"pointer"}}>
              {versions.map(v => <option key={v.version} value={v.version}>{v.display_label || v.version} — {v.branch}</option>)}
            </select>
          </div>
          <div style={{fontFamily:"var(--mono)",fontSize:14,fontWeight:800,color:"var(--amber)",textAlign:"center",paddingBottom:12}}>VS</div>
          <div>
            <div style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".12em",textTransform:"uppercase",color:"var(--muted)",marginBottom:6}}>Version B (newer)</div>
            <select value={versionB} onChange={e => setVersionB(e.target.value)}
              style={{width:"100%",background:"var(--bg3)",border:"1px solid var(--border2)",borderRadius:8,padding:"10px 14px",color:"var(--text)",fontFamily:"var(--mono)",fontSize:12,outline:"none",cursor:"pointer"}}>
              {versions.map(v => <option key={v.version} value={v.version}>{v.display_label || v.version} — {v.branch}</option>)}
            </select>
          </div>
        </div>

        {/* API filter */}
        <div style={{marginBottom:20}}>
          <div style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".12em",textTransform:"uppercase",color:"var(--muted)",marginBottom:6}}>API (optional)</div>
          <select value={domain} onChange={e => setDomain(e.target.value)}
            style={{width:"100%",background:"var(--bg3)",border:"1px solid var(--border2)",borderRadius:8,padding:"10px 14px",color:"var(--text)",fontFamily:"var(--mono)",fontSize:12,outline:"none",cursor:"pointer"}}>
            <option value="">(all APIs)</option>
            {domains.map(d => <option key={d.domain} value={d.domain}>{d.domain}</option>)}
          </select>
        </div>

        {/* Quick topics */}
        <div style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".12em",textTransform:"uppercase",color:"var(--muted)",marginBottom:10}}>Quick Comparisons</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:20}}>
          {QUICK_TOPICS.map((t, i) => (
            <button key={i} onClick={() => { setTopic(t.query); compare(t.query); }}
              disabled={comparing}
              style={{padding:"6px 14px",borderRadius:20,border:"1px solid var(--border2)",background:"transparent",
                color:"var(--muted)",fontFamily:"var(--mono)",fontSize:10,cursor:"pointer",transition:"all .2s"}}
              onMouseOver={e => { e.currentTarget.style.borderColor="#c9a84c"; e.currentTarget.style.color="#c9a84c"; e.currentTarget.style.background="rgba(201,168,76,.08)"; }}
              onMouseOut={e => { e.currentTarget.style.borderColor="var(--border2)"; e.currentTarget.style.color="var(--muted)"; e.currentTarget.style.background="transparent"; }}
            >{t.label}</button>
          ))}
        </div>

        {/* Custom topic */}
        <div style={{marginBottom:16}}>
          <div style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".12em",textTransform:"uppercase",color:"var(--muted)",marginBottom:6}}>Or ask your own question</div>
          <textarea value={topic} onChange={e => setTopic(e.target.value)}
            placeholder="e.g. What changed in the RepairOrder schema? Were any required fields added or removed?"
            style={{width:"100%",background:"var(--bg3)",border:"1px solid var(--border2)",borderRadius:8,padding:"10px 14px",
              color:"var(--text)",fontFamily:"var(--sans)",fontSize:13,outline:"none",resize:"vertical",minHeight:80,
              transition:"border-color .2s"}}
            onFocus={e => e.target.style.borderColor="#c9a84c"}
            onBlur={e => e.target.style.borderColor="var(--border2)"}
          />
        </div>

        <button onClick={() => compare()} disabled={comparing || !versionA || !versionB}
          style={{width:"100%",padding:13,borderRadius:9,border:"none",
            background:"linear-gradient(135deg, #c9a84c, #b8943d)",
            color:"#fff",fontFamily:"var(--sans)",fontWeight:700,fontSize:15,
            cursor:"pointer",transition:"opacity .2s",opacity: comparing ? .4 : 1}}>
          {comparing ? "Comparing versions…" : "⚡ Compare " + (versionA || "?") + " vs " + (versionB || "?")}
        </button>
      </div>

      {error && (
        <div style={{background:"rgba(239,68,68,.08)",border:"1px solid rgba(239,68,68,.3)",borderRadius:10,
          padding:"14px 18px",color:"#f87171",fontFamily:"var(--mono)",fontSize:12,marginBottom:20}}>
          ❌ {error}
        </div>
      )}

      {comparing && (
        <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:12,padding:"60px 20px",textAlign:"center"}}>
          <div style={{width:40,height:40,border:"3px solid var(--border2)",borderTopColor:"var(--amber)",
            borderRadius:"50%",animation:"spin 1s linear infinite",margin:"0 auto 16px"}} />
          <div style={{fontFamily:"var(--mono)",fontSize:12,color:"var(--muted)"}}>
            Querying {versionA} and {versionB} simultaneously…<br/>
            <span style={{fontSize:10,opacity:.7}}>This may take 60-90 seconds</span>
          </div>
        </div>
      )}

      {/* History of comparisons */}
      {history.length > 1 && (
        <div style={{marginBottom:20}}>
          <div style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".12em",textTransform:"uppercase",
            color:"var(--muted)",marginBottom:10,display:"flex",alignItems:"center",gap:8}}>
            Conversation History
            <button onClick={() => { setHistory([]); setResult(null); setError(null); setTopic(""); setFollowUp(""); }}
              style={{background:"transparent",border:"1px solid var(--border2)",borderRadius:4,
                color:"var(--dim)",fontFamily:"var(--mono)",fontSize:8,padding:"2px 8px",cursor:"pointer"}}>
              Clear
            </button>
          </div>
          {history.slice(0, -1).map((h, i) => (
            <div key={i} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:10,
              marginBottom:10,overflow:"hidden",opacity:.75}}>
              <div style={{background:"var(--bg3)",padding:"8px 16px",display:"flex",alignItems:"center",
                gap:8,borderBottom:"1px solid var(--border)"}}>
                <span style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--amber)"}}>{h.timestamp}</span>
                <span style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--dim)",flex:1,
                  overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{h.question}</span>
                <span style={{fontFamily:"var(--mono)",fontSize:9,color:"#60a5fa"}}>{h.versionA}</span>
                <span style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--dim)"}}>vs</span>
                <span style={{fontFamily:"var(--mono)",fontSize:9,color:"#10b981"}}>{h.versionB}</span>
              </div>
              <div className="compare-md" style={{padding:"12px 16px",fontSize:13,color:"var(--text)",maxHeight:200,overflowY:"auto"}}
                dangerouslySetInnerHTML={{__html: renderMarkdown(h.answer)}} />
            </div>
          ))}
        </div>
      )}

      {result && !comparing && (
        <div>
          <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:12,overflow:"hidden",marginBottom:16}}>
            <div style={{background:"var(--bg3)",padding:"14px 20px",display:"flex",alignItems:"center",gap:12,borderBottom:"1px solid var(--border)"}}>
              <span style={{fontFamily:"var(--mono)",fontSize:10,fontWeight:700,padding:"3px 10px",borderRadius:4,background:"rgba(96,165,250,.15)",color:"#60a5fa"}}>{result.versionA}</span>
              <span style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--dim)"}}>vs</span>
              <span style={{fontFamily:"var(--mono)",fontSize:10,fontWeight:700,padding:"3px 10px",borderRadius:4,background:"rgba(16,185,129,.15)",color:"#10b981"}}>{result.versionB}</span>
              {result.domain && <span style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--teal)",marginLeft:8}}>API: {result.domain}</span>}
              <span style={{marginLeft:"auto",fontFamily:"var(--mono)",fontSize:9,color:"var(--dim)"}}>
                {result.chunksA + result.chunksB} chunks retrieved
              </span>
              {/* Download button */}
              <DownloadButton
                getText={() => generateFullCompareReport(result, drillCache)}
                baseName={`star_compare_${result.versionA}_vs_${result.versionB}${result.domain ? "_" + result.domain : ""}`}
                label="Download Report"
                extraFormats={[{ format:"docx", label:"Word Doc (.docx)", handler: () => downloadCompareDocx(result, drillCache) }]}
              />
            </div>
            {/* Rendered markdown */}
            <div className="compare-md" style={{padding:24,lineHeight:1.8,color:"var(--text)",fontSize:14}}
              dangerouslySetInnerHTML={{__html: renderMarkdown(result.answer)}}
            />
          </div>

          {/* ── API Drill-Down Panel ─────────────────────────────────── */}
          {result.changedDomains?.length > 0 && (
            <DomainDrillDown
              result={result}
              authHeaders={authHeaders}
              API_URL={API_URL}
              drillCache={drillCache}
              setDrillCache={setDrillCache}
            />
          )}

          {/* Drill Deeper suggestions */}
          <div style={{background:"rgba(201,168,76,.06)",border:"1px solid rgba(201,168,76,.2)",
            borderRadius:10,padding:"16px 20px",marginBottom:16}}>
            <div style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".12em",textTransform:"uppercase",
              color:"var(--amber)",marginBottom:10}}>🔍 Drill Deeper</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
              {[
                { label: "List all APIs in " + result.versionB, query: "List all API domains and bounded contexts available. Show domain name, operation count, and schema count for each." },
                { label: "Find new APIs", query: "Which API domains or bounded contexts exist in " + result.versionB + " that did NOT exist in " + result.versionA + "? List only domains that are genuinely new." },
                { label: "Repair Order ops", query: "List all operations in the repair_order domain. Show method, path, operationId, and summary for each." },
                { label: "Part Invoice schemas", query: "List all schemas in the part_invoice domain. Show schema name, description, and property count." },
                { label: "Retail Delivery ops", query: "List all operations in the retail_delivery_report domain. Show method, path, and operationId." },
                { label: "Vehicle changes", query: "List all operations and schemas in the vehicle domain. Show complete details." },
              ].map((s, i) => (
                <button key={i} onClick={() => { setTopic(s.query); compare(s.query, true); }}
                  disabled={comparing}
                  style={{padding:"6px 14px",borderRadius:20,border:"1px solid rgba(201,168,76,.3)",
                    background:"transparent",color:"#e4c97e",fontFamily:"var(--mono)",fontSize:10,
                    cursor:"pointer",transition:"all .2s"}}
                  onMouseOver={e=>{e.currentTarget.style.background="rgba(201,168,76,.12)";}}
                  onMouseOut={e=>{e.currentTarget.style.background="transparent";}}
                >{s.label}</button>
              ))}
            </div>
          </div>

          {/* Follow-up question */}
          <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:10,padding:16}}>
            <div style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".12em",textTransform:"uppercase",
              color:"var(--muted)",marginBottom:10}}>💬 Ask a Follow-up Question</div>
            <div style={{display:"flex",gap:10}}>
              <input value={followUp} onChange={e => setFollowUp(e.target.value)}
                onKeyDown={e => { if (e.key === "Enter" && followUp.trim()) { compare(followUp, true); setFollowUp(""); } }}
                placeholder="e.g. Show me all operations in repair_order for v1.2.0..."
                style={{flex:1,background:"var(--bg3)",border:"1px solid var(--border2)",borderRadius:8,
                  padding:"10px 14px",color:"var(--text)",fontFamily:"var(--sans)",fontSize:13,outline:"none"}}
                onFocus={e=>e.target.style.borderColor="#c9a84c"}
                onBlur={e=>e.target.style.borderColor="var(--border2)"}
              />
              <button onClick={() => { if (followUp.trim()) { compare(followUp, true); setFollowUp(""); } }}
                disabled={comparing || !followUp.trim()}
                style={{padding:"10px 20px",borderRadius:8,border:"none",
                  background:"linear-gradient(135deg, #c9a84c, #b8943d)",
                  color:"#fff",fontFamily:"var(--sans)",fontWeight:700,fontSize:13,
                  cursor:"pointer",opacity: comparing || !followUp.trim() ? .4 : 1}}>
                Ask →
              </button>
            </div>
          </div>
          <div ref={historyEndRef} />
        </div>
      )}

      {!result && !comparing && !error && (
        <div style={{textAlign:"center",padding:"60px 0",fontFamily:"var(--mono)",color:"var(--dim)",fontSize:12}}>
          Select two versions above and click a quick comparison or enter your own question
        </div>
      )}
    </div>
  );
}

// ── Domain Explorer Tab ───────────────────────────────────────────────────
function DomainExplorerTab({ apiUrl, authHeaders, version }) {
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("domain");
  const [stats, setStats] = useState(null);
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [drillData, setDrillData] = useState(null);
  const [drillLoading, setDrillLoading] = useState(false);
  const [drillTab, setDrillTab] = useState("operations");
  const [selectedSchema, setSelectedSchema] = useState(null);
  const [schemaDetail, setSchemaDetail] = useState(null);
  const [schemaLoading, setSchemaLoading] = useState(false);

  useEffect(() => {
    const v = version && version !== "latest" ? `?version=${version}` : "";
    fetch(`${apiUrl}/stats/domains${v}`, { headers: authHeaders })
      .then(r => r.json())
      .then(data => {
        setDomains(data.domains || []);
        setStats({ total_domains: data.total_domains, total_operations: data.total_operations, total_schemas: data.total_schemas });
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [version]);

  const drillInto = async (domain) => {
    setSelectedDomain(domain);
    setSelectedSchema(null);
    setSchemaDetail(null);
    setDrillLoading(true);
    setDrillData(null);
    setDrillTab("operations");
    const v = version && version !== "latest" ? `&version=${version}` : "";
    try {
      const [opsRes, schemasRes, examplesRes] = await Promise.all([
        fetch(`${apiUrl}/lookup/operations?domain=${domain.domain}&limit=200${v}`, { headers: authHeaders }),
        fetch(`${apiUrl}/lookup/schemas?domain=${domain.domain}&limit=200${v}`, { headers: authHeaders }),
        fetch(`${apiUrl}/lookup/examples?domain=${domain.domain}${v}`, { headers: authHeaders }),
      ]);
      const [ops, schemas, examples] = await Promise.all([
        opsRes.ok ? opsRes.json() : { results: [] },
        schemasRes.ok ? schemasRes.json() : { results: [] },
        examplesRes.ok ? examplesRes.json() : { results: [] },
      ]);
      setDrillData({ ops: ops.results || [], schemas: schemas.results || [], examples: examples.results || [] });
    } catch(e) {
      setDrillData({ ops: [], schemas: [], examples: [] });
    }
    setDrillLoading(false);
  };

  const drillSchema = async (s) => {
    setSelectedSchema(s);
    setSchemaLoading(true);
    setSchemaDetail(null);
    const v = version && version !== "latest" ? `&version=${version}` : "";
    const schemaName = s.name || s.schema_name;
    try {
      const res = await fetch(
        `${apiUrl}/lookup/schemas/detail?domain=${selectedDomain.domain}&schema=${encodeURIComponent(schemaName)}${v}`,
        { headers: authHeaders }
      );
      const data = res.ok ? await res.json() : null;
      setSchemaDetail(data);
    } catch(e) { setSchemaDetail(null); }
    setSchemaLoading(false);
  };

  const filtered = domains
    .filter(d => d.domain.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => {
      if (sortBy === "operations") return b.operations - a.operations;
      if (sortBy === "schemas") return b.schemas - a.schemas;
      return a.domain.localeCompare(b.domain);
    });

  const MC = { GET:"#22c55e", POST:"#fbbf24", PUT:"#3b82f6", PATCH:"#8b5cf6", DELETE:"#ef4444" };

  return (
    <div style={{flex:1, overflow:"hidden", display:"flex", background:"var(--bg)"}}>

      {/* ── LEFT: API List ── */}
      <div style={{width: selectedDomain ? 260 : "100%", flexShrink:0,
        borderRight: selectedDomain ? "1px solid var(--border)" : "none",
        display:"flex", flexDirection:"column", overflow:"hidden"}}>
        <div style={{padding:"14px 16px", borderBottom:"1px solid var(--border)", flexShrink:0}}>
          <div style={{fontFamily:"var(--mono)",fontSize:12,fontWeight:700,letterSpacing:".06em",
            textTransform:"uppercase",color:"var(--text)",marginBottom:3}}>API Explorer</div>
          <div style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--muted)",marginBottom:10}}>
            {stats?.total_domains || "—"} domains · {stats?.total_operations?.toLocaleString() || "—"} operations
          </div>
          {!selectedDomain && stats && (
            <div style={{display:"flex",gap:8,marginBottom:10,flexWrap:"wrap"}}>
              {[{l:"Domains",v:stats.total_domains,c:"var(--purple)"},{l:"Operations",v:stats.total_operations?.toLocaleString(),c:"var(--teal)"},{l:"Schemas",v:stats.total_schemas?.toLocaleString(),c:"var(--blue)"}].map(s=>(
                <div key={s.l} style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:7,padding:"7px 12px"}}>
                  <div style={{fontFamily:"var(--mono)",fontSize:15,fontWeight:700,color:s.c}}>{s.v}</div>
                  <div style={{fontFamily:"var(--mono)",fontSize:8,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".06em"}}>{s.l}</div>
                </div>
              ))}
            </div>
          )}
          <div style={{display:"flex",gap:7}}>
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search domains..."
              style={{flex:1,background:"var(--bg2)",border:"1px solid var(--border2)",borderRadius:6,
                padding:"6px 10px",color:"var(--text)",fontFamily:"var(--mono)",fontSize:11,outline:"none"}}/>
            {!selectedDomain && (
              <select value={sortBy} onChange={e=>setSortBy(e.target.value)}
                style={{background:"var(--bg2)",border:"1px solid var(--border2)",borderRadius:6,
                  padding:"6px 8px",color:"var(--text)",fontFamily:"var(--mono)",fontSize:10,outline:"none"}}>
                <option value="domain">A→Z</option>
                <option value="operations">Most Ops</option>
                <option value="schemas">Most Schemas</option>
              </select>
            )}
          </div>
        </div>
        <div style={{flex:1,overflowY:"auto"}}>
          {loading ? <div style={{padding:16,fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)"}}>Loading…</div>
          : filtered.map((d,i) => (
            <div key={d.domain} onClick={()=>drillInto(d)}
              style={{padding:"9px 14px",borderBottom:"1px solid var(--border)",cursor:"pointer",
                background:selectedDomain?.domain===d.domain?"rgba(201,168,76,.1)":"transparent",
                borderLeft:selectedDomain?.domain===d.domain?"3px solid #e4c97e":"3px solid transparent"}}
              onMouseOver={e=>{if(selectedDomain?.domain!==d.domain)e.currentTarget.style.background="rgba(255,255,255,.03)";}}
              onMouseOut={e=>{if(selectedDomain?.domain!==d.domain)e.currentTarget.style.background="transparent";}}>
              <div style={{fontFamily:"var(--mono)",fontSize:11,fontWeight:600,marginBottom:2,
                color:selectedDomain?.domain===d.domain?"#e4c97e":"var(--text)"}}>
                {d.domain.replace(/_/g," ")}
              </div>
              <div style={{display:"flex",gap:7,fontFamily:"var(--mono)",fontSize:9,color:"var(--muted)",flexWrap:"wrap"}}>
                <span style={{color:"var(--teal)"}}>{d.operations} ops</span>
                <span>{d.schemas} schemas</span>
                {d.has_examples&&<span style={{color:"var(--green)"}}>{d.examples} ex</span>}
                {d.has_diagrams&&<>
                  <a href={d.clazz_diagram} target="_blank" rel="noopener noreferrer" onClick={e=>e.stopPropagation()}
                    style={{color:"var(--teal)",textDecoration:"none",border:"1px solid rgba(45,212,191,.3)",borderRadius:3,padding:"0 3px"}}>class↗</a>
                  <a href={d.context_diagram} target="_blank" rel="noopener noreferrer" onClick={e=>e.stopPropagation()}
                    style={{color:"var(--purple)",textDecoration:"none",border:"1px solid rgba(201,168,76,.3)",borderRadius:3,padding:"0 3px"}}>ctx↗</a>
                </>}
              </div>
            </div>
          ))}
          <div style={{padding:"6px 14px",fontFamily:"var(--mono)",fontSize:9,color:"var(--dim)"}}>{filtered.length} of {domains.length}</div>
        </div>
      </div>

      {/* ── MIDDLE: API Drill-down ── */}
      {selectedDomain && (
        <div style={{width:selectedSchema?320:"calc(100% - 260px)",flexShrink:0,overflow:"hidden",
          display:"flex",flexDirection:"column",borderRight:selectedSchema?"1px solid var(--border)":"none"}}>
          <div style={{padding:"12px 18px",borderBottom:"1px solid var(--border)",flexShrink:0,
            display:"flex",alignItems:"flex-start",justifyContent:"space-between"}}>
            <div>
              <div style={{fontFamily:"var(--mono)",fontSize:13,fontWeight:700,color:"var(--text)",marginBottom:3}}>
                {selectedDomain.domain.replace(/_/g," ").replace(/\w/g,c=>c.toUpperCase())}
              </div>
              <div style={{display:"flex",gap:8,fontFamily:"var(--mono)",fontSize:9,color:"var(--muted)",flexWrap:"wrap"}}>
                <span style={{color:"var(--teal)"}}>{selectedDomain.operations} ops</span>
                <span>{selectedDomain.schemas} schemas</span>
                {selectedDomain.has_examples&&<span style={{color:"var(--green)"}}>{selectedDomain.examples} examples</span>}
                {selectedDomain.has_diagrams&&<>
                  <a href={selectedDomain.clazz_diagram} target="_blank" rel="noopener noreferrer"
                    style={{color:"var(--teal)",textDecoration:"none",border:"1px solid rgba(45,212,191,.3)",borderRadius:3,padding:"0 5px"}}>Class↗</a>
                  <a href={selectedDomain.context_diagram} target="_blank" rel="noopener noreferrer"
                    style={{color:"var(--purple)",textDecoration:"none",border:"1px solid rgba(201,168,76,.3)",borderRadius:3,padding:"0 5px"}}>Context↗</a>
                </>}
              </div>
            </div>
            <button onClick={()=>{setSelectedDomain(null);setSelectedSchema(null);setSchemaDetail(null);}}
              style={{background:"transparent",border:"1px solid var(--border2)",borderRadius:4,
                color:"var(--muted)",fontSize:14,cursor:"pointer",padding:"2px 8px"}}>×</button>
          </div>
          <div style={{display:"flex",borderBottom:"1px solid var(--border)",flexShrink:0,background:"var(--bg2)"}}>
            {["operations","schemas","examples"].map(t=>(
              <button key={t} onClick={()=>{setDrillTab(t);setSelectedSchema(null);setSchemaDetail(null);}}
                style={{padding:"7px 14px",background:"none",border:"none",fontFamily:"var(--mono)",fontSize:10,
                  letterSpacing:".08em",textTransform:"uppercase",cursor:"pointer",
                  color:drillTab===t?"var(--text)":"var(--dim)",
                  borderBottom:drillTab===t?"2px solid var(--purple)":"2px solid transparent"}}>
                {t} {drillData&&<span style={{color:"var(--muted)",marginLeft:3}}>
                  ({t==="operations"?drillData.ops.length:t==="schemas"?drillData.schemas.length:drillData.examples.length})
                </span>}
              </button>
            ))}
          </div>
          <div style={{flex:1,overflowY:"auto",padding:14}}>
            {drillLoading ? <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)",padding:12}}>Loading…</div>
            : drillData && <>
              {drillTab==="operations" && (
                <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:8,overflow:"hidden"}}>
                  <div style={{display:"grid",gridTemplateColumns:"55px 1fr",padding:"6px 12px",background:"var(--bg3)",
                    fontFamily:"var(--mono)",fontSize:9,color:"var(--muted)",letterSpacing:".08em",textTransform:"uppercase",borderBottom:"1px solid var(--border)"}}>
                    <span>Method</span><span>Path / ID</span>
                  </div>
                  {drillData.ops.length===0
                    ? <div style={{padding:12,fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)"}}>No operations found.</div>
                    : drillData.ops.map((op,i)=>(
                      <div key={i} style={{display:"grid",gridTemplateColumns:"55px 1fr",padding:"7px 12px",
                        borderBottom:i<drillData.ops.length-1?"1px solid var(--border)":"none",alignItems:"start"}}
                        onMouseOver={e=>e.currentTarget.style.background="rgba(255,255,255,.03)"}
                        onMouseOut={e=>e.currentTarget.style.background="transparent"}>
                        <span style={{fontFamily:"var(--mono)",fontSize:10,fontWeight:700,color:MC[op.method]||"var(--muted)"}}>{op.method}</span>
                        <div>
                          <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--text)",wordBreak:"break-all"}}>{op.path}</div>
                          <div style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--dim)",marginTop:1}}>{op.operation_id}</div>
                        </div>
                      </div>
                    ))}
                </div>
              )}
              {drillTab==="schemas" && (
                <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:8,overflow:"hidden"}}>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",padding:"6px 12px",background:"var(--bg3)",
                    fontFamily:"var(--mono)",fontSize:9,color:"var(--muted)",letterSpacing:".08em",textTransform:"uppercase",borderBottom:"1px solid var(--border)"}}>
                    <span>Schema (click to inspect)</span><span>Description</span>
                  </div>
                  {drillData.schemas.length===0
                    ? <div style={{padding:12,fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)"}}>No schemas found.</div>
                    : drillData.schemas.map((s,i)=>(
                      <div key={i} onClick={()=>drillSchema(s)}
                        style={{display:"grid",gridTemplateColumns:"1fr 1fr",padding:"8px 12px",
                          borderBottom:i<drillData.schemas.length-1?"1px solid var(--border)":"none",cursor:"pointer",
                          background:selectedSchema===s?"rgba(96,165,250,.08)":"transparent",
                          borderLeft:selectedSchema===s?"3px solid #60a5fa":"3px solid transparent"}}
                        onMouseOver={e=>{if(selectedSchema!==s)e.currentTarget.style.background="rgba(255,255,255,.04)";}}
                        onMouseOut={e=>{if(selectedSchema!==s)e.currentTarget.style.background="transparent";}}>
                        <span style={{fontFamily:"var(--mono)",fontSize:11,fontWeight:600,
                          color:selectedSchema===s?"#60a5fa":"var(--blue)",
                          textDecoration:"underline",textDecorationColor:"rgba(96,165,250,.3)"}}>
                          {s.name||s.schema_name}
                        </span>
                        <span style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--muted)"}}>{s.description||"—"}</span>
                      </div>
                    ))}
                </div>
              )}
              {drillTab==="examples" && (
                drillData.examples.length===0
                  ? <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)",padding:12}}>No examples available.</div>
                  : drillData.examples.map((ex,i)=>(
                    <div key={i} style={{marginBottom:14,background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:8,overflow:"hidden"}}>
                      <div style={{padding:"9px 14px",background:"var(--bg3)",borderBottom:"1px solid var(--border)",
                        fontFamily:"var(--mono)",fontSize:11,color:"var(--purple)",fontWeight:600}}>
                        {ex.name||ex.filename||`Example ${i+1}`}
                      </div>
                      <pre style={{margin:0,padding:12,fontFamily:"var(--mono)",fontSize:10,color:"var(--text)",
                        overflowX:"auto",maxHeight:280,whiteSpace:"pre-wrap",wordBreak:"break-all"}}>
                        {ex.content||ex.text||JSON.stringify(ex,null,2)}
                      </pre>
                    </div>
                  ))
              )}
            </>}
          </div>
        </div>
      )}

      {/* ── RIGHT: Schema Detail ── */}
      {selectedSchema && (
        <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>
          <div style={{padding:"12px 18px",borderBottom:"1px solid var(--border)",flexShrink:0,
            display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <div>
              <div style={{fontFamily:"var(--mono)",fontSize:13,fontWeight:700,color:"#60a5fa",marginBottom:2}}>
                {selectedSchema.name||selectedSchema.schema_name}
              </div>
              <div style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--muted)"}}>
                {selectedDomain.domain} · schema properties
              </div>
            </div>
            <button onClick={()=>{setSelectedSchema(null);setSchemaDetail(null);}}
              style={{background:"transparent",border:"1px solid var(--border2)",borderRadius:4,
                color:"var(--muted)",fontSize:14,cursor:"pointer",padding:"2px 8px"}}>×</button>
          </div>
          <div style={{flex:1,overflowY:"auto",padding:14}}>
            {schemaLoading ? <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)",padding:12}}>Loading schema…</div>
            : schemaDetail ? <>
              {schemaDetail.schema?.description && (
                <div style={{marginBottom:14,padding:11,background:"var(--bg2)",border:"1px solid var(--border)",
                  borderRadius:8,fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)",lineHeight:1.6}}>
                  {schemaDetail.schema.description}
                </div>
              )}
              <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:8,overflow:"hidden"}}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 110px 50px",padding:"6px 12px",background:"var(--bg3)",
                  fontFamily:"var(--mono)",fontSize:9,color:"var(--muted)",letterSpacing:".08em",textTransform:"uppercase",borderBottom:"1px solid var(--border)"}}>
                  <span>Property</span><span>Type</span><span style={{textAlign:"center"}}>Req</span>
                </div>
                {(!schemaDetail.properties||schemaDetail.properties.length===0)
                  ? <div style={{padding:12,fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)"}}>No properties found.</div>
                  : schemaDetail.properties.map((p,i)=>(
                    <div key={i} style={{display:"grid",gridTemplateColumns:"1fr 110px 50px",padding:"8px 12px",
                      borderBottom:i<schemaDetail.properties.length-1?"1px solid var(--border)":"none",alignItems:"start"}}
                      onMouseOver={e=>e.currentTarget.style.background="rgba(255,255,255,.03)"}
                      onMouseOut={e=>e.currentTarget.style.background="transparent"}>
                      <div>
                        <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--text)",fontWeight:600}}>
                          {p.name||p.property_name}
                        </div>
                        {p.description&&<div style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--dim)",marginTop:2,lineHeight:1.5}}>{p.description}</div>}
                        {p.enum_values&&<div style={{fontFamily:"var(--mono)",fontSize:8,color:"var(--amber)",marginTop:2}}>
                          {(Array.isArray(p.enum_values)?p.enum_values:[p.enum_values]).join(" | ")}
                        </div>}
                      </div>
                      <div style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--teal)"}}>{p.type||p.property_type||"—"}</div>
                      <div style={{textAlign:"center",fontFamily:"var(--mono)",fontSize:12,color:p.required?"var(--green)":"var(--dim)"}}>
                        {p.required?"✓":"—"}
                      </div>
                    </div>
                  ))}
              </div>
            </>
            : <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)",padding:12}}>Could not load schema details.</div>}
          </div>
        </div>
      )}
    </div>
  );
}

function UsageTab({ apiUrl, authHeaders }) {
  const [summary, setSummary] = useState(null);
  const [users, setUsers] = useState(null);
  const [events, setEvents] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [days, setDays] = useState(30);
  const [activeView, setActiveView] = useState("summary");
  const [generating, setGenerating] = useState(false);

  useEffect(() => { loadData(); }, [days]);

  const loadData = async () => {
    setLoading(true); setError(null);
    try {
      const [sumRes, usrRes, evtRes] = await Promise.all([
        fetch(`${apiUrl}/usage/summary?days=${days}`, { headers: authHeaders }),
        fetch(`${apiUrl}/usage/users?days=${days}`, { headers: authHeaders }),
        fetch(`${apiUrl}/usage/events?days=${days}&limit=200`, { headers: authHeaders }),
      ]);
      if (sumRes.status === 403) { setError("Admin access required"); setLoading(false); return; }
      const [s, u, e] = await Promise.all([sumRes.json(), usrRes.json(), evtRes.json()]);
      setSummary(s); setUsers(u); setEvents(e);
    } catch(e) { setError(e.message); }
    finally { setLoading(false); }
  };

  const formatDate = (ts) => ts ? new Date(ts).toLocaleString() : "—";
  const formatMs = (ms) => ms ? `${ms}ms` : "—";

  const generatePDF = () => {
    if (!summary || !users) return;
    setGenerating(true);
    const periodLabel = `Last ${days} days`;
    const generatedAt = new Date().toLocaleString();

    const html = `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8"/>
<title>STAR Platform Usage Report</title>
<style>
  * { margin:0; padding:0; box-sizing:border-box; }
  body { font-family: Arial, sans-serif; color: #1a1f2e; background: white; }
  .cover { background: #1a1f2e; color: white; padding: 60px 50px; min-height: 200px; }
  .cover h1 { font-size: 32px; color: #c9a84c; margin-bottom: 8px; }
  .cover h2 { font-size: 18px; font-weight: 400; color: #a0a0b0; margin-bottom: 24px; }
  .cover .meta { font-size: 12px; color: #6b7280; font-family: monospace; }
  .cover .period { font-size: 14px; color: #c9a84c; margin-top: 8px; }
  .content { padding: 40px 50px; }
  h3 { font-size: 16px; color: #1a1f2e; border-bottom: 2px solid #c9a84c;
       padding-bottom: 6px; margin: 32px 0 16px; text-transform: uppercase;
       letter-spacing: .08em; font-size: 12px; }
  .kpi-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-bottom: 32px; }
  .kpi { background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 8px;
         padding: 16px; text-align: center; }
  .kpi .val { font-size: 28px; font-weight: 800; color: #c9a84c; }
  .kpi .lbl { font-size: 10px; color: #6b7280; text-transform: uppercase;
               letter-spacing: .08em; margin-top: 4px; }
  table { width: 100%; border-collapse: collapse; font-size: 12px; margin-bottom: 24px; }
  th { background: #1a1f2e; color: white; padding: 8px 12px; text-align: left;
       font-size: 10px; text-transform: uppercase; letter-spacing: .08em; }
  td { padding: 8px 12px; border-bottom: 1px solid #e5e7eb; }
  tr:nth-child(even) td { background: #f9fafb; }
  .badge { padding: 2px 8px; border-radius: 4px; font-size: 10px; font-weight: 700;
           font-family: monospace; }
  .badge-query { background: #dbeafe; color: #1e40af; }
  .badge-validate { background: #ede9fe; color: #5b21b6; }
  .badge-build { background: #dcfce7; color: #166534; }
  .bar-row { display: flex; align-items: center; gap: 12px; margin-bottom: 8px; }
  .bar-label { width: 120px; font-size: 11px; font-family: monospace; color: #374151; }
  .bar-bg { flex: 1; background: #e5e7eb; border-radius: 4px; height: 10px; }
  .bar-fill { height: 100%; background: #c9a84c; border-radius: 4px; }
  .bar-count { width: 40px; text-align: right; font-size: 11px; color: #6b7280; font-family: monospace; }
  .footer { margin-top: 40px; padding-top: 16px; border-top: 1px solid #e5e7eb;
            font-size: 10px; color: #9ca3af; text-align: center; }
  @media print {
    body { print-color-adjust: exact; -webkit-print-color-adjust: exact; }
    .cover { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    th { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  }
</style>
</head>
<body>

<div class="cover">
  <h1>⭐ STAR Developer Platform</h1>
  <h2>User Activity Report</h2>
  <div class="period">Period: ${periodLabel} &nbsp;·&nbsp; Generated: ${generatedAt}</div>
  <div class="meta" style="margin-top:16px">Confidential — Internal Use Only</div>
</div>

<div class="content">

  <h3>Executive Summary</h3>
  <div class="kpi-grid">
    <div class="kpi"><div class="val">${summary.total_events ?? 0}</div><div class="lbl">Total Events</div></div>
    <div class="kpi"><div class="val">${summary.unique_users ?? 0}</div><div class="lbl">Unique Users</div></div>
    <div class="kpi"><div class="val">${summary.active_users_7d ?? 0}</div><div class="lbl">Active Users</div></div>
    <div class="kpi"><div class="val">${summary.avg_query_ms ? Math.round(summary.avg_query_ms) + 'ms' : '—'}</div><div class="lbl">Avg Response</div></div>
  </div>

  <h3>Activity by Tool</h3>
  ${Object.entries(summary.by_type || {}).map(([type, count]) => `
    <div class="bar-row">
      <div class="bar-label">${type}</div>
      <div class="bar-bg"><div class="bar-fill" style="width:${Math.round(count/(summary.total_events||1)*100)}%"></div></div>
      <div class="bar-count">${count}</div>
    </div>
  `).join('')}

  <h3>Daily Activity — Last ${days} Days</h3>
  <table>
    <tr><th>Date</th><th>Events</th></tr>
    ${(summary.per_day || []).map(d => `<tr><td>${d.day}</td><td>${d.events}</td></tr>`).join('')}
  </table>

  <h3>Top APIs Queried</h3>
  <table>
    <tr><th>API</th><th>Query Count</th></tr>
    ${(summary.top_domains || []).map(d => `<tr><td>${d.domain}</td><td>${d.count}</td></tr>`).join('')}
  </table>

  <h3>Versions Used</h3>
  <table>
    <tr><th>Version</th><th>Events</th></tr>
    ${(summary.top_versions || []).map(v => `<tr><td>${v.version || 'default'}</td><td>${v.count}</td></tr>`).join('')}
  </table>

  <h3>User Activity Detail</h3>
  <table>
    <tr><th>Email</th><th>Total</th><th>Queries</th><th>Validations</th><th>Builds</th><th>Last Active</th><th>First Active</th></tr>
    ${(users.users || []).map(u => `
      <tr>
        <td>${u.email}</td>
        <td><strong>${u.total_events}</strong></td>
        <td>${u.queries}</td>
        <td>${u.validations}</td>
        <td>${u.builds}</td>
        <td>${u.last_active ? new Date(u.last_active).toLocaleString() : '—'}</td>
        <td>${u.first_active ? new Date(u.first_active).toLocaleString() : '—'}</td>
      </tr>
    `).join('')}
  </table>

  ${(events?.events?.length > 0) ? `
  <h3>Recent Activity Log (last 200 events)</h3>
  <table>
    <tr><th>Time</th><th>Type</th><th>User</th><th>Tool</th><th>Version</th><th>Domain</th><th>Response</th></tr>
    ${events.events.map(e => `
      <tr>
        <td style="font-family:monospace;font-size:10px">${e.ts ? new Date(e.ts).toLocaleString() : '—'}</td>
        <td><span class="badge badge-${e.event_type}">${e.event_type}</span></td>
        <td>${e.user_email || '—'}</td>
        <td style="font-family:monospace;font-size:10px">${e.tool || '—'}</td>
        <td style="font-family:monospace;font-size:10px">${e.version || '—'}</td>
        <td style="font-family:monospace;font-size:10px">${e.domain || '—'}</td>
        <td style="font-family:monospace;font-size:10px">${e.response_ms ? e.response_ms + 'ms' : '—'}</td>
      </tr>
    `).join('')}
  </table>` : ''}

  <div class="footer">
    STAR Developer Platform Usage Report &nbsp;·&nbsp; ${periodLabel} &nbsp;·&nbsp; Generated ${generatedAt}<br/>
    Confidential — Internal Use Only &nbsp;·&nbsp; starstandard.org
  </div>

</div>
</body>
</html>`;

    // Open in new window and trigger print dialog
    const win = window.open('', '_blank');
    win.document.write(html);
    win.document.close();
    win.onload = () => {
      win.focus();
      win.print();
      setGenerating(false);
    };
  };

  if (loading) return (
    <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:16}}>
      <div style={{width:40,height:40,border:"3px solid var(--border2)",borderTopColor:"var(--amber)",
        borderRadius:"50%",animation:"spin 1s linear infinite"}} />
      <div style={{fontFamily:"var(--mono)",fontSize:12,color:"var(--muted)"}}>Loading usage data…</div>
    </div>
  );

  if (error) return (
    <div style={{flex:1,padding:32}}>
      <div style={{background:"rgba(239,68,68,.08)",border:"1px solid rgba(239,68,68,.3)",borderRadius:10,
        padding:"16px 20px",color:"#f87171",fontFamily:"var(--mono)",fontSize:12}}>❌ {error}</div>
    </div>
  );

  return (
    <div style={{flex:1,overflowY:"auto",padding:"28px 32px",background:"var(--bg)"}}>
      {/* Header */}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:24}}>
        <div>
          <div style={{fontSize:20,fontWeight:800,color:"var(--text)",marginBottom:4}}>📊 Usage Dashboard</div>
          <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)"}}>Admin view — member activity across all three tools</div>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          {[7,30,90].map(d => (
            <button key={d} onClick={() => setDays(d)}
              style={{padding:"6px 14px",borderRadius:6,border:"1px solid",cursor:"pointer",
                fontFamily:"var(--mono)",fontSize:10,fontWeight:700,transition:"all .2s",
                borderColor: days===d ? "var(--amber)" : "var(--border2)",
                background: days===d ? "rgba(201,168,76,.15)" : "var(--bg3)",
                color: days===d ? "var(--amber)" : "var(--muted)"}}>
              {d}d
            </button>
          ))}
          <button onClick={loadData}
            style={{padding:"6px 14px",borderRadius:6,border:"1px solid var(--border2)",
              cursor:"pointer",fontFamily:"var(--mono)",fontSize:10,color:"var(--dim)",
              background:"var(--bg3)",transition:"all .2s"}}>
            ↻ Refresh
          </button>
          <button onClick={generatePDF} disabled={generating || !summary}
            style={{padding:"6px 14px",borderRadius:6,border:"1px solid rgba(201,168,76,.4)",
              cursor:"pointer",fontFamily:"var(--mono)",fontSize:10,color:"#e4c97e",
              background:"rgba(201,168,76,.1)",transition:"all .2s",
              opacity: (!summary || generating) ? .5 : 1}}>
            {generating ? "Generating…" : "📄 Export PDF"}
          </button>
        </div>
      </div>

      {/* KPI Cards */}
      {summary && (
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:16,marginBottom:24}}>
          {[
            { label: "Total Events", value: summary.total_events?.toLocaleString(), color: "var(--amber)" },
            { label: "Unique Users", value: summary.unique_users, color: "#4ade80" },
            { label: "Active Users", value: summary.active_users_7d, color: "#60a5fa" },
            { label: "Avg Response", value: formatMs(summary.avg_query_ms), color: "#a78bfa" },
          ].map((k, i) => (
            <div key={i} style={{background:"var(--bg2)",border:"1px solid var(--border)",
              borderRadius:10,padding:"18px 20px"}}>
              <div style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".12em",
                textTransform:"uppercase",color:"var(--muted)",marginBottom:8}}>{k.label}</div>
              <div style={{fontSize:28,fontWeight:800,color:k.color}}>{k.value ?? "—"}</div>
            </div>
          ))}
        </div>
      )}

      {/* View tabs */}
      <div style={{display:"flex",gap:0,marginBottom:20,borderRadius:8,overflow:"hidden",
        border:"1px solid var(--border2)",width:"fit-content"}}>
        {["summary","users","events"].map(v => (
          <button key={v} onClick={() => setActiveView(v)}
            style={{padding:"8px 20px",border:"none",cursor:"pointer",
              fontFamily:"var(--mono)",fontSize:10,letterSpacing:".06em",textTransform:"uppercase",
              background: activeView===v ? "var(--amber)" : "var(--bg3)",
              color: activeView===v ? "#1a1f2e" : "var(--muted)",fontWeight: activeView===v ? 700 : 400}}>
            {v === "summary" ? "📈 Summary" : v === "users" ? "👥 Users" : "📋 Events"}
          </button>
        ))}
      </div>

      {/* Summary View */}
      {activeView === "summary" && summary && (
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:20}}>
          {/* Events by type */}
          <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:10,padding:20}}>
            <div style={{fontFamily:"var(--mono)",fontSize:10,letterSpacing:".1em",textTransform:"uppercase",
              color:"var(--amber)",marginBottom:14}}>Events by Type</div>
            {Object.entries(summary.by_type || {}).map(([type, count], i) => (
              <div key={i} style={{display:"flex",alignItems:"center",gap:12,marginBottom:10}}>
                <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--text)",width:80}}>{type}</div>
                <div style={{flex:1,background:"var(--bg3)",borderRadius:4,height:8,overflow:"hidden"}}>
                  <div style={{height:"100%",background:"var(--amber)",borderRadius:4,
                    width:`${Math.round(count/summary.total_events*100)}%`}} />
                </div>
                <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)",width:40,textAlign:"right"}}>{count}</div>
              </div>
            ))}
          </div>

          {/* Top domains */}
          <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:10,padding:20}}>
            <div style={{fontFamily:"var(--mono)",fontSize:10,letterSpacing:".1em",textTransform:"uppercase",
              color:"var(--amber)",marginBottom:14}}>Top APIs Queried</div>
            {(summary.top_domains || []).map((d, i) => (
              <div key={i} style={{display:"flex",alignItems:"center",gap:12,marginBottom:10}}>
                <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--teal)",flex:1}}>{d.domain}</div>
                <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)"}}>{d.count}</div>
              </div>
            ))}
            {(summary.top_domains || []).length === 0 && (
              <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--dim)"}}>No API queries yet</div>
            )}
          </div>

          {/* Activity per day */}
          <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:10,padding:20,gridColumn:"1/-1"}}>
            <div style={{fontFamily:"var(--mono)",fontSize:10,letterSpacing:".1em",textTransform:"uppercase",
              color:"var(--amber)",marginBottom:14}}>Daily Activity (last {days} days)</div>
            <div style={{display:"flex",alignItems:"flex-end",gap:3,height:80}}>
              {(summary.per_day || []).slice().reverse().map((d, i) => {
                const max = Math.max(...(summary.per_day||[]).map(x=>x.events));
                const h = max > 0 ? Math.max(4, Math.round(d.events/max*80)) : 4;
                return (
                  <div key={i} title={`${d.day}: ${d.events} events`}
                    style={{flex:1,background:"var(--amber)",borderRadius:"2px 2px 0 0",
                      height:h,opacity:.7,cursor:"default",transition:"opacity .2s"}}
                    onMouseOver={e=>e.target.style.opacity="1"}
                    onMouseOut={e=>e.target.style.opacity=".7"}
                  />
                );
              })}
            </div>
            <div style={{display:"flex",justifyContent:"space-between",marginTop:4,
              fontFamily:"var(--mono)",fontSize:8,color:"var(--dim)"}}>
              <span>{(summary.per_day||[]).slice(-1)[0]?.day || ""}</span>
              <span>{(summary.per_day||[])[0]?.day || ""}</span>
            </div>
          </div>

          {/* Versions used */}
          <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:10,padding:20}}>
            <div style={{fontFamily:"var(--mono)",fontSize:10,letterSpacing:".1em",textTransform:"uppercase",
              color:"var(--amber)",marginBottom:14}}>Versions Used</div>
            {(summary.top_versions || []).map((v, i) => (
              <div key={i} style={{display:"flex",gap:12,marginBottom:8}}>
                <div style={{fontFamily:"var(--mono)",fontSize:11,color:"#e4c97e",flex:1}}>{v.version || "default"}</div>
                <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)"}}>{v.count}</div>
              </div>
            ))}
          </div>

          {/* Top users */}
          <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:10,padding:20}}>
            <div style={{fontFamily:"var(--mono)",fontSize:10,letterSpacing:".1em",textTransform:"uppercase",
              color:"var(--amber)",marginBottom:14}}>Top Users</div>
            {(summary.top_users || []).map((u, i) => (
              <div key={i} style={{display:"flex",gap:12,marginBottom:8}}>
                <div style={{fontSize:12,color:"var(--text)",flex:1}}>{u.email}</div>
                <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)"}}>{u.events}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Users View */}
      {activeView === "users" && users && (
        <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:10,overflow:"hidden"}}>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
            <thead>
              <tr style={{background:"var(--bg3)"}}>
                {["Email","Total","Queries","Validations","Builds","Last Active","First Active"].map((h,i) => (
                  <th key={i} style={{padding:"10px 14px",textAlign:"left",fontFamily:"var(--mono)",
                    fontSize:9,letterSpacing:".1em",textTransform:"uppercase",color:"var(--amber)",
                    borderBottom:"1px solid var(--border)"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(users.users || []).map((u, i) => (
                <tr key={i} style={{background: i%2===0?"transparent":"rgba(255,255,255,.02)"}}>
                  <td style={{padding:"10px 14px",color:"var(--text)",fontWeight:600}}>{u.email}</td>
                  <td style={{padding:"10px 14px",fontFamily:"var(--mono)",fontSize:12,color:"var(--amber)",fontWeight:700}}>{u.total_events}</td>
                  <td style={{padding:"10px 14px",fontFamily:"var(--mono)",fontSize:12,color:"var(--teal)"}}>{u.queries}</td>
                  <td style={{padding:"10px 14px",fontFamily:"var(--mono)",fontSize:12,color:"#a78bfa"}}>{u.validations}</td>
                  <td style={{padding:"10px 14px",fontFamily:"var(--mono)",fontSize:12,color:"#4ade80"}}>{u.builds}</td>
                  <td style={{padding:"10px 14px",fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)"}}>{formatDate(u.last_active)}</td>
                  <td style={{padding:"10px 14px",fontFamily:"var(--mono)",fontSize:11,color:"var(--dim)"}}>{formatDate(u.first_active)}</td>
                </tr>
              ))}
              {(users.users || []).length === 0 && (
                <tr><td colSpan={7} style={{padding:"32px",textAlign:"center",color:"var(--dim)",
                  fontFamily:"var(--mono)",fontSize:12}}>No user activity recorded yet</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Events View */}
      {activeView === "events" && events && (
        <div style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:10,overflow:"hidden"}}>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
            <thead>
              <tr style={{background:"var(--bg3)"}}>
                {["Time","Type","User","Tool","Version","API","Query","Response"].map((h,i) => (
                  <th key={i} style={{padding:"10px 14px",textAlign:"left",fontFamily:"var(--mono)",
                    fontSize:9,letterSpacing:".1em",textTransform:"uppercase",color:"var(--amber)",
                    borderBottom:"1px solid var(--border)"}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(events.events || []).map((e, i) => (
                <tr key={i} style={{background: i%2===0?"transparent":"rgba(255,255,255,.02)"}}>
                  <td style={{padding:"8px 14px",fontFamily:"var(--mono)",fontSize:10,color:"var(--dim)",whiteSpace:"nowrap"}}>{formatDate(e.ts)}</td>
                  <td style={{padding:"8px 14px"}}>
                    <span style={{fontFamily:"var(--mono)",fontSize:9,fontWeight:700,padding:"2px 8px",
                      borderRadius:4,
                      background: e.event_type==="query"?"rgba(96,165,250,.15)":e.event_type==="validate"?"rgba(167,139,250,.15)":"rgba(74,222,128,.15)",
                      color: e.event_type==="query"?"#60a5fa":e.event_type==="validate"?"#a78bfa":"#4ade80"}}>
                      {e.event_type}
                    </span>
                  </td>
                  <td style={{padding:"8px 14px",fontSize:11,color:"var(--text)"}}>{e.user_email}</td>
                  <td style={{padding:"8px 14px",fontFamily:"var(--mono)",fontSize:10,color:"var(--muted)"}}>{e.tool}</td>
                  <td style={{padding:"8px 14px",fontFamily:"var(--mono)",fontSize:10,color:"#e4c97e"}}>{e.version || "—"}</td>
                  <td style={{padding:"8px 14px",fontFamily:"var(--mono)",fontSize:10,color:"var(--teal)"}}>{e.domain || "—"}</td>
                  <td style={{padding:"8px 14px",fontSize:11,color:"var(--muted)",maxWidth:200,
                    overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}
                    title={e.query_text}>{e.query_text || "—"}</td>
                  <td style={{padding:"8px 14px",fontFamily:"var(--mono)",fontSize:10,color:"var(--dim)"}}>{formatMs(e.response_ms)}</td>
                </tr>
              ))}
              {(events.events || []).length === 0 && (
                <tr><td colSpan={8} style={{padding:"32px",textAlign:"center",color:"var(--dim)",
                  fontFamily:"var(--mono)",fontSize:12}}>No events recorded yet</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}


// ── Main App ───────────────────────────────────────────────────────────────
export default function App() {
  const [token, setToken] = useState(() => localStorage.getItem("star_token"));
  const [userEmail, setUserEmail] = useState(() => localStorage.getItem("star_email") || "");
  const [theme, setTheme] = useState(() => localStorage.getItem("star_theme") || "dark");

  // Apply theme to document
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("star_theme", theme);
  }, [theme]);
  const [audience, setAudience] = useState("developer");
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [domain, setDomain] = useState("");
  const [loading, setLoading] = useState(false);
  const [domains, setDomains] = useState([]);
  const [health, setHealth] = useState(null);
  const [showAudience, setShowAudience] = useState(true);
  const [activeTab, setActiveTab] = useState("chat");
  const [version, setVersion] = useState("latest");
  const [versions, setVersions] = useState([]);

  // Conversation history state
  const [conversations, setConversations] = useState([]);
  const [currentConvId, setCurrentConvId] = useState(null);
  const currentConvIdRef = useRef(null);
  const [showHistory, setShowHistory] = useState(true); // left sidebar visible by default
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [includeXml5, setIncludeXml5] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showScrollBottom, setShowScrollBottom] = useState(false);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  const chatContainerRef = useRef(null);
  const userScrolledRef = useRef(false);

  const aud = AUDIENCES[audience];

  const handleLogin = (tok, email) => {
    setToken(tok); setUserEmail(email);
    // Log login event
    setTimeout(() => {
      fetch(`${API_URL}/usage/event`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${tok}` },
        body: JSON.stringify({ event_type: "login", tool: "intelligence" }),
      }).catch(() => {});
    }, 500);
  };

  const handleLogout = useCallback(() => {
    // Log logout event before clearing token
    if (token) {
      fetch(`${API_URL}/usage/event`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
        body: JSON.stringify({ event_type: "logout", tool: "intelligence" }),
      }).catch(() => {});
    }
    localStorage.removeItem("star_token");
    localStorage.removeItem("star_email");
    setToken(null); setUserEmail(""); setMessages([]); setDomains([]); setHealth(null);
    setConversations([]); setCurrentConvId(null);
  }, [token]);

  // ── Conversation history helpers ───────────────────────────────────────────

  const generateConvId = () => `conv_${Date.now()}_${Math.random().toString(36).slice(2,8)}`;

  const fetchConversations = useCallback(async () => {
    if (!token) return;
    setHistoryLoading(true);
    try {
      const res = await fetch(`${API_URL}/conversations`, { headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` } });
      const data = await res.json();
      setConversations(data.conversations || []);
    } catch(e) {} finally {
      setHistoryLoading(false);
    }
  }, [token]);

  const saveConversation = useCallback(async (msgs, convId, ver, dom, aud) => {
    if (!token || !msgs.length) return;
    try {
      await fetch(`${API_URL}/conversations/save`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
        body: JSON.stringify({
          conversation_id: convId,
          version: ver !== "latest" ? ver : null,
          domain: dom || null,
          audience: aud,
          messages: msgs.map(m => ({
            role: m.role, text: m.text,
            chunks_used: m.chunks || 0,
            audience: m.audience || aud,
          })),
        }),
      });
      fetchConversations();
    } catch(e) {}
  }, [token, fetchConversations]);

  const loadConversation = useCallback(async (convId) => {
    try {
      const res = await fetch(`${API_URL}/conversations/${convId}`, {
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` }
      });
      const data = await res.json();
      setMessages(data.messages.map(m => ({
        role: m.role, text: m.text,
        chunks: m.chunks_used, audience: m.audience,
        time: new Date(m.created_at),
      })));
      setCurrentConvId(convId);
      currentConvIdRef.current = convId;
      if (data.version) setVersion(data.version);
      if (data.domain) setDomain(data.domain);
      if (data.audience) setAudience(data.audience);
      setShowHistory(false);
      setActiveTab("chat");
    } catch(e) {}
  }, [token]);

  const deleteConversation = useCallback(async (convId, e) => {
    e.stopPropagation();
    try {
      await fetch(`${API_URL}/conversations/${convId}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
      });
      setConversations(prev => prev.filter(c => c.id !== convId));
      if (currentConvId === convId) {
        setMessages([]); setCurrentConvId(null);
        currentConvIdRef.current = null;
      }
    } catch(e) {}
  }, [token, currentConvId]);

  const startNewChat = useCallback(() => {
    setMessages([]); 
    setCurrentConvId(null);
    currentConvIdRef.current = null;
    setShowHistory(false); setActiveTab("chat");
    setTimeout(() => inputRef.current?.focus(), 100);
  }, []);

  // Auth headers for all API calls — memoized so it doesn't cause re-renders
  const authHeaders = useMemo(() => ({
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`
  }), [token]);

  // Fetch health + domains + versions + conversations on mount
  useEffect(() => {
    if (!token) return;
    fetch(`${API_URL}/health`, { headers: authHeaders })
      .then(r => r.json())
      .then(d => setHealth(d))
      .catch(() => setHealth({ status: "error" }));
    fetchConversations();

    fetch(`${API_URL}/domains`, { headers: authHeaders })
      .then(r => r.json())
      .then(d => setDomains(d.domains || []))
      .catch(() => {});

    fetch(`${API_URL}/versions`, { headers: authHeaders })
      .then(r => r.json())
      .then(d => {
        const v = d.versions || [];
        setVersions(v);
        if (v.length > 0) setVersion(v[0].version); // default to latest
      })
      .catch(() => {});
  }, [token]);

  // Re-fetch domain count when version changes
  useEffect(() => {
    if (!token || !version) return;
    fetch(`${API_URL}/domains?version=${version}`, { headers: authHeaders })
      .then(r => r.json())
      .then(d => setDomains(d.domains || []))
      .catch(() => {});
  }, [version, token]);

  // Scroll to bottom on new messages — respects user scroll position during streaming
  useEffect(() => {
    if (!userScrolledRef.current) {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, loading]);

  // Reset scroll lock when new user message is sent
  const resetScrollLock = () => { userScrolledRef.current = false; };

  // Handle scroll events on the messages container
  const handleMessagesScroll = useCallback(() => {
    const el = chatContainerRef.current;
    if (!el) return;
    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 80;
    if (atBottom) {
      userScrolledRef.current = false;
    } else {
      // Only lock if we're streaming
      const isStreaming = messages.some(m => m.streaming);
      if (isStreaming) userScrolledRef.current = true;
    }
    // Show "Back to Top" button when scrolled down > 300px
    setShowScrollTop(el.scrollTop > 300);
    // Show "Jump to Bottom" button when not near the bottom
    setShowScrollBottom(el.scrollHeight - el.scrollTop - el.clientHeight > 300);
  }, [messages]);

  const sendQuery = useCallback(async (queryText, domainFilter) => {
    if (!queryText.trim() || loading) return;
    userScrolledRef.current = false;
    if (!currentConvIdRef.current) {
      const newId = generateConvId();
      currentConvIdRef.current = newId;
      setCurrentConvId(newId);
    }
    const userMsg = { role: "user", text: queryText, audience, time: new Date() };
    setMessages(prev => [...prev, userMsg]);
    setInput("");
    setLoading(true);

    // ── Domain list interception — bypass Claude, use /domains directly ──────
    const _ql = queryText.toLowerCase();
    const _isDomainList = ["list all domain","list the domain","all 83 domain","all APIs",
      "show all domain","what are the domain","how many domain","show the domains",
      "all api domain","all bounded context","list bounded context",
    ].some(p => _ql.includes(p));

    if (_isDomainList) {
      try {
        const res = await fetch(`${API_URL}/domains?version=${version === "latest" ? "main" : version}`,
          { headers: authHeaders });
        const data = await res.json();
        const domains = data.domains || [];
        const totalOps = domains.reduce((s, d) => s + (d.operations || 0), 0);
        const totalSchemas = domains.reduce((s, d) => s + (d.schemas || 0), 0);
        let md = `# STAR Domain Model — All ${domains.length} Domains\n\n`;
        md += `> Source: authoritative platform database · Version: **${version === "latest" ? "main" : version}**\n\n`;
        md += `| # | API | Operations | Schemas | Examples |\n`;
        md += `|---|-----|------------|---------|----------|\n`;
        domains.forEach((d, i) => {
          md += `| ${i+1} | \`${d.domain}\` | ${d.operations} | ${d.schemas} | ${d.examples || 0} |\n`;
        });
        md += `\n**Totals: ${domains.length} domains · ${totalOps} operations · ${totalSchemas} schemas**`;
        setMessages(prev => [
          ...prev.slice(0, -0),
          { role: "assistant", text: md, chunks: domains.length,
            audience, time: new Date(), streaming: false }
        ]);
        setLoading(false);
        return;
      } catch(e) {
        // fall through to normal Claude query on error
      }
    }
    // ─────────────────────────────────────────────────────────────────────────

    // Add a streaming placeholder message immediately
    const placeholderMsg = {
      role: "assistant", text: "", chunks: 0,
      audience, time: new Date(), streaming: true,
    };
    setMessages(prev => [...prev, placeholderMsg]);

    try {
      const payload = {
        query: `[Explain this for a ${aud.label}: ${aud.prompt}]\n\n${queryText}`,
        top_k: 15,
        domain: domainFilter || domain || null,
        include_chunks: false,
        include_xml5: includeXml5,
        model: "claude-sonnet-4-6",
        version: version !== "latest" ? version : null,
        // Send last 6 messages as history for conversational context
        history: messages.slice(-6).map(m => ({
          role: m.role,
          text: m.text || "",
        })),
      };

      const res = await fetch(`${API_URL}/query/stream`, {
        method: "POST",
        headers: authHeaders,
        body: JSON.stringify(payload),
      });

      // Handle auth errors
      if (res.status === 401 || res.status === 403) {
        const errData = await res.json().catch(() => ({}));
        const isExpired = (errData.detail || "").toLowerCase().includes("expir") ||
                         (errData.detail || "").toLowerCase().includes("invalid token");
        const friendlyMsg = isExpired
          ? "⏱ Your session has expired after 24 hours. Please sign out and sign back in to continue."
          : "🔒 Authentication error. Please sign out and sign back in.";
        setMessages(prev => {
          const msgs = [...prev];
          msgs[msgs.length - 1] = { role: "assistant", text: friendlyMsg, audience, time: new Date(), isError: true };
          return msgs;
        });
        setLoading(false);
        return;
      }

      // Read SSE stream
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      let chunksUsed = 0;
      let fullText = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split("\n");
        buffer = lines.pop(); // keep incomplete line

        for (const line of lines) {
          if (!line.startsWith("data: ")) continue;
          try {
            const event = JSON.parse(line.slice(6));
            if (event.type === "meta") {
              chunksUsed = event.chunks_used || 0;
            } else if (event.type === "text") {
              fullText += event.text;
              // Update the streaming message in place
              setMessages(prev => {
                const msgs = [...prev];
                msgs[msgs.length - 1] = {
                  ...msgs[msgs.length - 1],
                  text: fullText,
                  chunks: chunksUsed,
                  streaming: true,
                };
                return msgs;
              });
            } else if (event.type === "done") {
              // Mark streaming complete
              let finalMsgs;
              setMessages(prev => {
                const msgs = [...prev];
                msgs[msgs.length - 1] = {
                  ...msgs[msgs.length - 1],
                  text: fullText,
                  chunks: chunksUsed,
                  streaming: false,
                };
                finalMsgs = msgs;
                return msgs;
              });
              // Auto-save conversation after state update
              setTimeout(() => {
                if (finalMsgs) {
                  const convId = currentConvIdRef.current || generateConvId();
                  if (!currentConvIdRef.current) {
                    currentConvIdRef.current = convId;
                    setCurrentConvId(convId);
                  }
                  saveConversation(finalMsgs, convId, version, domain, audience);
                }
              }, 100);
            } else if (event.type === "error") {
              setMessages(prev => {
                const msgs = [...prev];
                msgs[msgs.length - 1] = {
                  role: "assistant", text: `Error: ${event.error}`,
                  audience, time: new Date(), isError: true, streaming: false,
                };
                return msgs;
              });
            }
          } catch (e) { /* skip malformed events */ }
        }
      }
    } catch (err) {
      setMessages(prev => {
        const msgs = [...prev];
        msgs[msgs.length - 1] = {
          role: "assistant", text: `Error: ${err.message}`,
          audience, time: new Date(), isError: true, streaming: false,
        };
        return msgs;
      });
    } finally {
      setLoading(false);
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [loading, aud, audience, domain, authHeaders, handleLogout, includeXml5]);

  const handleQuickPrompt = (qp) => {
    sendQuery(qp.query, qp.domain);
    setShowAudience(false);
  };

  const formatTime = (d) => d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  // Show login screen if not authenticated
  if (!token) return <LoginScreen onLogin={handleLogin} />;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&family=JetBrains+Mono:wght@300;400;500&family=Crimson+Pro:ital,wght@0,300;0,400;1,300;1,400&display=swap');

        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        .stream-cursor { display: inline-block; color: #fbbf24; animation: blink 0.8s step-end infinite; margin-left: 2px; }
        @keyframes blink { 0%,100% { opacity: 1; } 50% { opacity: 0; } }

        :root {
          --bg:      #1c1c2e;
          --bg2:     #242438;
          --bg3:     #2a2a42;
          --border:  #363660;
          --border2: #424268;
          --text:    #f0eeff;
          --muted:   #c8c5e0;
          --dim:     #9a98b5;
          --purple:  #e4c97e;
          --teal:    #2dd4bf;
          --amber:   #fbbf24;
          --blue:    #38bdf8;
          --green:   #34d399;
          --pink:    #f472b6;
          --mono:    'JetBrains Mono', monospace;
          --serif:   'Crimson Pro', Georgia, serif;
          --sans:    'Syne', sans-serif;
        }

        /* ── RESPONSIVE LAYOUTS ── */
        @media (max-width: 768px) {
          .topbar { padding: 0 12px; gap: 6px; flex-wrap: wrap; min-height: 44px; }
          .topbar .stats { display: none; }
          .history-sidebar { width: 200px; }
          .history-sidebar.collapsed { width: 0; }
          .tab-btn { padding: 8px 12px; font-size: 9px; letter-spacing: .06em; }
          .messages { padding: 12px; }
          .msg-ai-body { padding: 14px; }
          .input-area { padding: 8px 12px; }
          .aud-panel { padding: 12px; }
          .lookup-container { padding: 12px; }
        }

        @media (max-width: 480px) {
          .history-sidebar { display: none; }
          .topbar { padding: 0 8px; }
          .tab-btn { padding: 6px 8px; font-size: 8px; }
          .send-btn { width: 36px; height: 36px; font-size: 16px; }
        }

        /* ── END RESPONSIVE ── */
        [data-theme="light"] {
          --bg:      #f5f4f0;
          --bg2:     #eeecea;
          --bg3:     #e5e3df;
          --border:  #d0cdc8;
          --border2: #bfbcb7;
          --text:    #0a0a1a;
          --muted:   #1e1e38;
          --dim:     #3a3a58;
          --purple:  #c9a84c;
          --teal:    #0d9488;
          --amber:   #b45309;
          --blue:    #1d4ed8;
          --green:   #059669;
          --pink:    #be185d;
          --mono:    'JetBrains Mono', monospace;
          --serif:   'Crimson Pro', Georgia, serif;
          --sans:    'Syne', sans-serif;
        }

        [data-theme="light"] body {
          background: #f5f4f0 !important;
          color: #0a0a1a !important;
        }

        [data-theme="light"] .topbar {
          background: #ffffff !important;
          border-bottom: 1px solid #d0cdc8 !important;
          color: #1a1a2e !important;
        }

        [data-theme="light"] .topbar * {
          color: #1a1a2e !important;
          border-color: #d0cdc8 !important;
        }

        [data-theme="light"] .topbar a {
          color: #b45309 !important;
          border-color: rgba(180,83,9,.35) !important;
        }

        [data-theme="light"] .topbar button {
          color: #1a1a2e !important;
          border-color: #bfbcb7 !important;
          background: transparent !important;
        }

        [data-theme="light"] .topbar select {
          background: #f5f4f0 !important;
          color: #1a1a2e !important;
          border-color: #bfbcb7 !important;
        }

        [data-theme="light"] .topbar select option {
          background: #ffffff !important;
          color: #1a1a2e !important;
        }

        [data-theme="light"] .stats span { color: #1a1a2e !important; }
        [data-theme="light"] .stats strong { color: #b45309 !important; }

        [data-theme="light"] .tabs {
          background: #eeecea !important;
          border-bottom-color: #d0cdc8 !important;
        }

        [data-theme="light"] .tab-btn { color: #5a5a70 !important; }
        [data-theme="light"] .tab-btn.active { color: #1a1a2e !important; }
        [data-theme="light"] .tab-btn.active::after { background: #b45309 !important; }

        [data-theme="light"] .history-sidebar {
          background: #eeecea !important;
          border-right-color: #d0cdc8 !important;
        }

        [data-theme="light"] .history-sidebar-header {
          border-bottom-color: #d0cdc8 !important;
        }

        [data-theme="light"] .history-sidebar-title { color: #5a5a70 !important; }
        [data-theme="light"] .history-new-btn {
          background: rgba(180,83,9,.08) !important;
          border-color: rgba(180,83,9,.25) !important;
          color: #b45309 !important;
        }

        [data-theme="light"] .history-item:hover { background: rgba(0,0,0,.04) !important; }
        [data-theme="light"] .history-item.active {
          background: rgba(180,83,9,.08) !important;
          border-left-color: #b45309 !important;
        }
        [data-theme="light"] .history-item-title { color: #1a1a2e !important; }
        [data-theme="light"] .history-item.active .history-item-title { color: #b45309 !important; }
        [data-theme="light"] .history-item-meta { color: #5a5a70 !important; }

        [data-theme="light"] .msg-ai-body {
          background: #ffffff !important;
          border-color: #d0cdc8 !important;
        }

        [data-theme="light"] .msg-ai-content { color: #1a1a2e !important; }
        [data-theme="light"] .msg-ai-content h1,
        [data-theme="light"] .msg-ai-content h2,
        [data-theme="light"] .msg-ai-content h3,
        [data-theme="light"] .msg-ai-content h4 { color: #1a1a2e !important; border-color: #d0cdc8 !important; }
        [data-theme="light"] .msg-ai-content p,
        [data-theme="light"] .msg-ai-content li { color: #1a1a2e !important; }
        [data-theme="light"] .msg-ai-content strong { color: #1a1a2e !important; }
        [data-theme="light"] .msg-ai-content code {
          background: #e5e3df !important;
          color: #1a1a2e !important;
          border-color: #bfbcb7 !important;
        }
        [data-theme="light"] .msg-ai-content pre {
          background: #1a1a2e !important;
          border-color: #d0cdc8 !important;
        }
        [data-theme="light"] .msg-ai-content pre code {
          background: transparent !important;
          color: #e8e8f0 !important;
        }
        [data-theme="light"] .msg-ai-content th {
          background: #e5e3df !important;
          color: #1a1a2e !important;
          border-color: #bfbcb7 !important;
        }
        [data-theme="light"] .msg-ai-content td {
          color: #1a1a2e !important;
          border-color: #d0cdc8 !important;
        }
        [data-theme="light"] .msg-ai-content tr:nth-child(even) td { background: #f5f4f0 !important; }
        [data-theme="light"] .msg-ai-content blockquote {
          border-left-color: #b45309 !important;
          color: #3a3a50 !important;
          background: #eeecea !important;
        }
        [data-theme="light"] .msg-ai-content a { color: #1d4ed8 !important; }
        [data-theme="light"] .msg-ai-content hr { border-color: #d0cdc8 !important; }

        [data-theme="light"] .input-bar {
          background: #ffffff !important;
          border-top-color: #d0cdc8 !important;
        }
        [data-theme="light"] .input-hint { color: #3a3a50 !important; }
        [data-theme="light"] .input-bar select,
        [data-theme="light"] .input-bar textarea,
        [data-theme="light"] .input-bar input {
          background: #f5f4f0 !important;
          color: #1a1a2e !important;
          border-color: #bfbcb7 !important;
        }
        [data-theme="light"] .input-bar select option { background: #ffffff !important; color: #1a1a2e !important; }
        [data-theme="light"] .clear-btn { color: #3a3a50 !important; border-color: #bfbcb7 !important; }
        [data-theme="light"] .send-btn { background: #b45309 !important; color: #ffffff !important; }

        [data-theme="light"] .stream-cursor { color: #b45309; }
        [data-theme="light"] ::-webkit-scrollbar-thumb { background: #bfbcb7; }

        [data-theme="light"] .topbar {
          background: #d0d0e4;
          border-bottom-color: #b8b8d0;
          color: #0f0f1e;
        }

        [data-theme="light"] .topbar * {
          color: #0f0f1e !important;
          border-color: #d0cfe8 !important;
        }

        [data-theme="light"] .topbar a {
          color: #c9a84c !important;
          border-color: rgba(201,168,76,.4) !important;
        }

        [data-theme="light"] .topbar button {
          color: #1a1a2e !important;
          border-color: #c0bfdc !important;
          background: transparent !important;
        }

        [data-theme="light"] .topbar select {
          background: #e0e0ec !important;
          color: #0f0f1e !important;
          border-color: #b0afcc !important;
        }

        [data-theme="light"] .topbar select option {
          background: #e4e4f0 !important;
          color: #0f0f1e !important;
        }

        [data-theme="light"] .stats span { color: #0f0f1e !important; }
        [data-theme="light"] .stats strong { color: #c9a84c !important; }

        /* Input bar in light mode */
        [data-theme="light"] .input-bar {
          background: #dcdcec !important;
          border-top-color: #c0bfd8 !important;
        }

        [data-theme="light"] .input-hint {
          color: #1a1a2e !important;
        }

        [data-theme="light"] .input-bar select,
        [data-theme="light"] .input-bar textarea,
        [data-theme="light"] .input-bar input {
          background: #e4e4f0 !important;
          color: #0f0f1e !important;
          border-color: #b0afcc !important;
        }

        [data-theme="light"] .input-bar select option {
          background: #e4e4f0 !important;
          color: #0f0f1e !important;
        }

        [data-theme="light"] .clear-btn {
          color: #1a1a2e !important;
          border-color: #b0afcc !important;
        }

        [data-theme="light"] .send-btn {
          background: #d97706 !important;
          color: #ffffff !important;
        }

        /* Theme toggle button — make moon clearly visible */
        [data-theme="light"] .topbar button[title*="dark"] {
          color: #1a1a2e !important;
          font-size: 16px !important;
        }

        [data-theme="light"] .history-sidebar {
          background: #f0f0f8;
          border-right-color: #d0cfe8;
        }

        [data-theme="light"] .history-sidebar-header {
          border-bottom-color: #d0cfe8;
        }

        [data-theme="light"] .history-item:hover {
          background: rgba(0,0,0,.04);
        }

        [data-theme="light"] .history-item.active {
          background: rgba(201,168,76,.12);
        }

        [data-theme="light"] .msg-ai-content { color: #0f0f1e; }
        [data-theme="light"] .msg-ai-content h1,
        [data-theme="light"] .msg-ai-content h2,
        [data-theme="light"] .msg-ai-content h3,
        [data-theme="light"] .msg-ai-content h4 { color: #0f0f1e !important; border-color: #d0cfe8 !important; }
        [data-theme="light"] .msg-ai-content p { color: #0f0f1e; }
        [data-theme="light"] .msg-ai-content strong { color: #0f0f1e; }
        [data-theme="light"] .msg-ai-content em { color: #2a2848; }
        [data-theme="light"] .msg-ai-content code {
          background: #e8e8f4 !important;
          color: #1a1a2e !important;
          border-color: #c0bfdc !important;
        }
        [data-theme="light"] .msg-ai-content pre {
          background: #e8e8f4 !important;
          border-color: #c0bfdc !important;
        }
        [data-theme="light"] .msg-ai-content pre code { color: #1a1a2e !important; }
        [data-theme="light"] .msg-ai-content table { border-color: #c0bfdc !important; }
        [data-theme="light"] .msg-ai-content th {
          background: #e8e8f4 !important;
          color: #0f0f1e !important;
          border-color: #c0bfdc !important;
        }
        [data-theme="light"] .msg-ai-content td {
          color: #0f0f1e !important;
          border-color: #d0cfe8 !important;
        }
        [data-theme="light"] .msg-ai-content tr:nth-child(even) td {
          background: #f0f0f8 !important;
        }
        [data-theme="light"] .msg-ai-content blockquote {
          border-left-color: #c9a84c !important;
          color: #2a2848 !important;
          background: #f0f0f8 !important;
        }
        [data-theme="light"] .msg-ai-content a { color: #0284c7 !important; }
        [data-theme="light"] .msg-ai-content li { color: #0f0f1e; }
        [data-theme="light"] .msg-ai-content hr { border-color: #d0cfe8 !important; }

        [data-theme="light"] .msg-user-bubble {
          background: #e8e8f4;
          color: #1a1a2e;
        }

        [data-theme="light"] .input-area {
          background: #ffffff;
          border-top-color: #d0cfe8;
        }

        [data-theme="light"] .tab-bar {
          background: #f0f0f8;
          border-bottom-color: #d0cfe8;
        }

        [data-theme="light"] .tab-btn {
          color: #6a6890;
        }

        [data-theme="light"] .tab-btn.active {
          color: #c9a84c;
          border-bottom-color: #c9a84c;
        }

        [data-theme="light"] .stream-cursor { color: #d97706; }

        [data-theme="light"] ::-webkit-scrollbar-thumb { background: #c0bfdc; }

        html, body, #root { height: 100%; overflow: hidden; }

        body {
          font-family: var(--sans);
          background: #1c1c2e;
          color: var(--text);
          font-size: 15px;
          line-height: 1.7;
        }

        /* Scrollbars */
        ::-webkit-scrollbar { width: 3px; height: 3px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: var(--border2); border-radius: 2px; }

        /* App layout */
        .app { display: flex; flex-direction: column; height: 100vh; }

        /* Topbar */
        .topbar {
          display: flex; align-items: center; gap: 20px;
          padding: 10px 24px; border-bottom: 1px solid var(--border);
          background: #1c1c2e; flex-shrink: 0;
          position: relative; z-index: 10;
        }
        .topbar::after {
          content: ''; position: absolute; bottom: -1px; left: 0; right: 0;
          height: 1px; background: linear-gradient(90deg, var(--purple) 0%, var(--teal) 50%, transparent 100%);
          opacity: 0.4;
        }
        .logo {
          font-family: var(--serif); font-style: italic;
          font-size: 20px; color: var(--text); letter-spacing: -0.02em;
          flex-shrink: 0;
        }
        .logo span { color: var(--purple); }
        .stats {
          display: flex; gap: 16px;
          font-family: var(--mono); font-size: 9px; color: #c0bdd8;
          letter-spacing: .08em; text-transform: uppercase;
        }
        .stats strong { color: #e0ddff; font-weight: 500; }
        .aud-badge {
          margin-left: auto; display: flex; align-items: center; gap: 6px;
          font-family: var(--mono); font-size: 9px; letter-spacing: .08em;
          color: #c0bdd8; text-transform: uppercase;
        }
        .aud-dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; }
        .status-dot {
          width: 6px; height: 6px; border-radius: 50%;
          background: #22c55e; box-shadow: 0 0 6px #22c55e;
          flex-shrink: 0; animation: pulse 2s infinite;
        }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.4} }

        /* Tabs */
        .tabs {
          display: flex; gap: 0; border-bottom: 1px solid var(--border);
          padding: 0 24px; background: var(--bg2); flex-shrink: 0;
        }
        .tab-btn {
          padding: 10px 20px; background: none; border: none;
          font-family: var(--mono); font-size: 10px; letter-spacing: .1em;
          text-transform: uppercase; color: var(--dim); cursor: pointer;
          position: relative; transition: color .15s;
        }
        .tab-btn.active { color: var(--text); }
        .tab-btn.active::after {
          content: ''; position: absolute; bottom: -1px; left: 0; right: 0;
          height: 2px; background: var(--purple);
        }
        .tab-btn:hover:not(.active) { color: var(--dim); }

        /* Main content */
        .main { flex: 1; overflow: hidden; display: flex; flex-direction: row; }

        /* ── CHAT TAB ── */
        .chat-container { flex: 1; overflow: hidden; display: flex; flex-direction: column; }
        /* ── LEFT HISTORY SIDEBAR ── */
        .history-sidebar {
          width: 240px; flex-shrink: 0;
          background: #141422; border-right: 1px solid #1e1e30;
          display: flex; flex-direction: column;
          height: 100%; overflow: hidden;
          transition: width .2s ease;
        }
        .history-sidebar.collapsed { width: 0; overflow: hidden; }
        .history-sidebar-header {
          padding: 12px 14px; border-bottom: 1px solid #1e1e30;
          display: flex; align-items: center; justify-content: space-between;
          flex-shrink: 0;
        }
        .history-sidebar-title {
          font-family: var(--mono); font-size: 9px; letter-spacing: .12em;
          text-transform: uppercase; color: var(--muted);
        }
        .history-new-btn {
          width: calc(100% - 28px); margin: 10px 14px;
          font-family: var(--mono); font-size: 10px; letter-spacing: .06em;
          background: rgba(201,168,76,.08); border: 1px solid rgba(201,168,76,.25);
          border-radius: 6px; color: #e4c97e; padding: 8px;
          cursor: pointer; transition: all .15s; text-align: left;
          flex-shrink: 0;
        }
        .history-new-btn:hover { background: rgba(201,168,76,.15); border-color: rgba(201,168,76,.5); }
        .history-list { flex: 1; overflow-y: auto; padding: 4px 0; }
        .history-item {
          padding: 8px 14px; cursor: pointer;
          border-bottom: 1px solid rgba(255,255,255,.03);
          transition: background .12s; display: flex;
          align-items: flex-start; gap: 8; justify-content: space-between;
        }
        .history-item:hover { background: rgba(255,255,255,.04); }
        .history-item.active { background: rgba(201,168,76,.08); border-left: 2px solid #e4c97e; }
        .history-item-body { flex: 1; min-width: 0; }
        .history-item-title {
          font-family: var(--mono); font-size: 10px; color: var(--text);
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
          margin-bottom: 2px; line-height: 1.3;
        }
        .history-item.active .history-item-title { color: #e4c97e; }
        .history-item-meta {
          font-family: var(--mono); font-size: 8px; color: var(--muted);
          display: flex; gap: 8px;
        }
        .history-item-del {
          background: transparent; border: none; color: #333;
          font-size: 14px; cursor: pointer; padding: 0 2px;
          flex-shrink: 0; line-height: 1; transition: color .15s;
          opacity: 0;
        }
        .history-item:hover .history-item-del { opacity: 1; }
        .history-item-del:hover { color: #ef4444; }
        .history-toggle-btn {
          background: transparent; border: none;
          color: var(--muted); font-size: 14px; cursor: pointer;
          padding: 2px 4px; transition: color .15s; line-height: 1;
        }
        .history-toggle-btn:hover { color: var(--text); }
        .content-area { flex: 1; overflow: hidden; display: flex; flex-direction: column; }


        /* Audience panel */
        .aud-toggle {
          display: flex; align-items: center; gap: 8px;
          padding: 8px 24px; background: none; border: none;
          border-bottom: 1px solid transparent; cursor: pointer;
          font-family: var(--mono); font-size: 9px; letter-spacing: .1em;
          text-transform: uppercase; color: var(--muted); transition: color .15s;
          text-align: left; width: 100%;
        }
        .aud-toggle:hover { color: var(--text); }
        .aud-toggle-icon { transition: transform .2s; }
        .aud-toggle-icon.open { transform: rotate(90deg); }

        .aud-panel {
          background: var(--bg2); border-bottom: 1px solid var(--border);
          padding: 16px 24px; display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px; overflow: hidden;
          animation: slideDown .2s ease;
        }
        @keyframes slideDown { from{opacity:0;transform:translateY(-8px)} to{opacity:1;transform:none} }

        .aud-section h4 {
          font-family: var(--mono); font-size: 8px; letter-spacing: .14em;
          text-transform: uppercase; color: var(--muted); margin-bottom: 8px;
        }

        .aud-buttons { display: flex; flex-wrap: wrap; gap: 6px; }
        .aud-btn {
          display: flex; align-items: center; gap: 6px;
          padding: 6px 12px; background: var(--bg3);
          border: 1px solid var(--border2); border-radius: 4px;
          font-family: var(--mono); font-size: 9px; letter-spacing: .06em;
          color: var(--muted); cursor: pointer; transition: all .15s;
        }
        .aud-btn:hover { color: var(--text); border-color: var(--dim); }
        .aud-btn.active { color: var(--text); border-color: var(--purple); background: rgba(167,139,250,.08); }

        .qp-buttons { display: flex; flex-wrap: wrap; gap: 6px; }
        .qp-btn {
          padding: 5px 10px; background: var(--bg3);
          border: 1px solid var(--border); border-radius: 3px;
          font-family: var(--mono); font-size: 8px; letter-spacing: .04em;
          color: var(--muted); cursor: pointer; transition: all .15s;
        }
        .qp-btn:hover { color: var(--text); border-color: var(--purple); background: rgba(167,139,250,.06); }

        /* Messages */
        .messages {
          flex: 1; overflow-y: scroll; padding: 24px;
          display: flex; flex-direction: column; gap: 20px;
          position: relative;
        }
        .messages::-webkit-scrollbar { width: 8px; }
        .messages::-webkit-scrollbar-track { background: var(--bg2); border-radius: 4px; }
        .messages::-webkit-scrollbar-thumb { background: #4a4a6a; border-radius: 4px; }
        .messages::-webkit-scrollbar-thumb:hover { background: #6a6a8a; }

        .empty-state {
          flex: 1; display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          gap: 12px; text-align: center; padding: 60px 40px;
        }
        .empty-glyph {
          font-family: var(--serif); font-style: italic;
          font-size: 56px; color: var(--border2); line-height: 1;
          letter-spacing: -0.04em;
        }
        .empty-title {
          font-family: var(--serif); font-style: italic;
          font-size: 22px; color: var(--dim); font-weight: 300;
        }
        .empty-hint {
          font-family: var(--mono); font-size: 10px;
          color: var(--muted); letter-spacing: .08em;
        }
        .empty-badge {
          font-family: var(--mono); font-size: 9px;
          color: var(--muted); padding: 5px 14px;
          border: 1px solid var(--border2); border-radius: 20px;
          margin-top: 8px;
        }

        /* User message */
        .msg-user { display: flex; justify-content: flex-end; }
        .msg-user-inner { max-width: 680px; }
        .msg-user-bubble {
          background: rgba(167,139,250,.08);
          border: 1px solid rgba(167,139,250,.18);
          border-radius: 12px 12px 2px 12px;
          padding: 12px 16px;
          font-family: var(--sans); font-size: 14px;
          color: var(--text); line-height: 1.6;
        }
        .msg-meta {
          font-family: var(--mono); font-size: 11px;
          color: var(--muted); margin-top: 6px;
          display: flex; align-items: center; gap: 8px;
        }
        .msg-meta-right { justify-content: flex-end; }
        .msg-aud-tag {
          padding: 2px 8px; border-radius: 8px;
          font-family: var(--mono); font-size: 11px;
          background: rgba(167,139,250,.08);
        }

        /* AI message */
        .msg-ai { display: flex; gap: 12px; }
        .msg-ai-avatar {
          width: 26px; height: 26px; border-radius: 50%;
          background: var(--bg3); border: 1px solid var(--border2);
          display: flex; align-items: center; justify-content: center;
          font-size: 11px; flex-shrink: 0; margin-top: 2px;
          color: var(--purple);
        }
        .msg-ai-body { flex: 1; max-width: 820px; }
        .msg-ai-content {
          font-family: var(--sans); font-size: 15px;
          color: var(--text); line-height: 1.8;
        }
        .msg-ai-content h1 { font-size: 20px; font-weight: 700; color: #fff; margin: 18px 0 10px; }
        .msg-ai-content h2 { font-size: 17px; font-weight: 600; color: #fff; margin: 16px 0 8px; }
        .msg-ai-content h3 { font-family: var(--mono); font-size: 11px; letter-spacing: .1em; text-transform: uppercase; color: var(--teal); margin: 14px 0 6px; }
        .msg-ai-content p { margin-bottom: 12px; color: #f0eeff; font-size: 15px; }
        .msg-ai-content strong { color: #fff; font-weight: 600; }
        .msg-ai-content em { color: var(--muted); font-style: italic; }
        .msg-ai-content ul { padding-left: 20px; margin-bottom: 12px; }
        .msg-ai-content li { margin-bottom: 6px; color: #f0eeff; font-size: 15px; }
        .msg-ai-content table { width: 100%; border-collapse: collapse; margin: 12px 0; font-size: 13.5px; border: 1px solid var(--border2); border-radius: 6px; overflow: hidden; }
        .msg-ai-content th { background: var(--bg3); color: #f0dfa0; padding: 8px 12px; text-align: left; font-family: var(--mono); font-size: 10px; letter-spacing: .08em; text-transform: uppercase; border-bottom: 2px solid var(--purple); }
        .msg-ai-content td { padding: 8px 12px; border-bottom: 1px solid var(--border); color: var(--text); }
        /* Compare result markdown styles */
        .compare-md h1, .compare-md h2, .compare-md h3 { color: var(--amber); margin: 20px 0 10px; font-weight: 700; }
        .compare-md h1 { font-size: 20px; } .compare-md h2 { font-size: 17px; } .compare-md h3 { font-size: 15px; }
        .compare-md p { margin-bottom: 12px; color: var(--text); }
        .compare-md ul, .compare-md ol { margin: 8px 0 12px 24px; }
        .compare-md li { margin-bottom: 6px; color: var(--text); }
        .compare-md table { width: 100%; border-collapse: collapse; margin: 14px 0; font-size: 13px; }
        .compare-md th { background: var(--bg3); color: #e4c97e; padding: 8px 12px; text-align: left; font-family: var(--mono); font-size: 10px; letter-spacing: .08em; border-bottom: 2px solid var(--amber); }
        .compare-md td { padding: 8px 12px; border-bottom: 1px solid var(--border); color: var(--text); }
        .compare-md tr:nth-child(even) td { background: rgba(255,255,255,.02); }
        .compare-md code { font-family: var(--mono); font-size: 12px; background: var(--bg3); padding: 2px 6px; border-radius: 4px; color: #e4c97e; }
        .compare-md pre { background: var(--bg3); padding: 14px; border-radius: 8px; overflow-x: auto; margin: 12px 0; }
        .compare-md blockquote { border-left: 3px solid var(--amber); padding: 8px 16px; margin: 12px 0; background: rgba(201,168,76,.06); color: var(--muted); }
        .msg-ai-content tr:last-child td { border-bottom: none; }
        .msg-ai-content tr:nth-child(even) td { background: rgba(167,139,250,.06); }
        .msg-ai-content blockquote { border-left: 3px solid var(--amber); padding: 8px 14px; margin: 10px 0; color: var(--muted); font-style: italic; background: rgba(251,191,36,.05); border-radius: 0 4px 4px 0; }
        .inline-code { font-family: var(--mono); font-size: 12.5px; background: var(--bg3); color: var(--teal); padding: 2px 6px; border-radius: 3px; border: 1px solid var(--border2); }
        .code-block-wrap { position: relative; margin: 12px 0; }
        .code-block-wrap .code-block { margin: 0; }
        .code-copy-btn {
          position: absolute; top: 8px; right: 8px;
          background: rgba(42,42,66,.9); border: 1px solid var(--border2);
          border-radius: 4px; padding: 3px 9px;
          font-family: var(--mono); font-size: 10px; color: var(--muted);
          cursor: pointer; transition: all .15s; letter-spacing: .06em; z-index: 2;
          line-height: 1.6;
        }
        .code-copy-btn:hover { background: rgba(201,168,76,.15); color: var(--amber); border-color: rgba(201,168,76,.4); }
        .code-block { background: #2a2a42; border: 1px solid var(--border); border-left: 3px solid var(--purple); border-radius: 6px; padding: 16px 18px; margin: 12px 0; overflow-x: auto; font-family: var(--mono); font-size: 12.5px; color: #f0dfa0; line-height: 1.8; }
        /* Back to top button */
        .back-to-top-btn {
          position: sticky; bottom: 12px; align-self: flex-end;
          background: rgba(30,58,95,.92); border: 1px solid rgba(228,201,126,.35);
          border-radius: 20px; padding: 5px 14px;
          font-family: var(--mono); font-size: 11px; color: #e4c97e;
          cursor: pointer; transition: all .2s; letter-spacing: .06em;
          box-shadow: 0 2px 10px rgba(0,0,0,.4); z-index: 5;
          display: flex; align-items: center; gap: 5px;
        }
        .back-to-top-btn:hover { background: rgba(201,168,76,.25); border-color: #e4c97e; }
        /* Jump to bottom button */
        .back-to-bottom-btn {
          position: sticky; top: 12px; align-self: flex-end;
          background: rgba(30,58,95,.92); border: 1px solid rgba(228,201,126,.35);
          border-radius: 20px; padding: 5px 14px;
          font-family: var(--mono); font-size: 11px; color: #e4c97e;
          cursor: pointer; transition: all .2s; letter-spacing: .06em;
          box-shadow: 0 2px 10px rgba(0,0,0,.4); z-index: 5;
          display: flex; align-items: center; gap: 5px;
        }
        .back-to-bottom-btn:hover { background: rgba(201,168,76,.25); border-color: #e4c97e; }

        /* Loading */
        .loading-dots { display: flex; gap: 4px; align-items: center; padding: 4px 0; }
        .loading-dot { width: 5px; height: 5px; border-radius: 50%; background: var(--purple); animation: blink 1.2s infinite; }
        .loading-dot:nth-child(2) { animation-delay: .2s; }
        .loading-dot:nth-child(3) { animation-delay: .4s; }
        @keyframes blink { 0%,100%{opacity:.2} 50%{opacity:1} }

        /* Input bar */
        .input-bar {
          padding: 16px 24px; border-top: 1px solid var(--border);
          background: #1c1c2e; flex-shrink: 0;
        }
        .input-hint {
          font-family: var(--mono); font-size: 8px; letter-spacing: .1em;
          text-transform: uppercase; color: var(--muted); margin-bottom: 8px;
        }
        .input-row { display: flex; gap: 8px; align-items: flex-end; }
        .input-selects { display: flex; gap: 6px; margin-bottom: 8px; }
        .input-select {
          flex: 1; padding: 6px 10px; background: var(--bg3);
          border: 1px solid var(--border2); border-radius: 4px;
          color: var(--text); font-family: var(--mono); font-size: 10px;
          outline: none; cursor: pointer;
        }
        .input-select:focus { border-color: var(--purple); }
        .input-textarea {
          flex: 1; padding: 10px 14px; background: var(--bg3);
          border: 1px solid var(--border2); border-radius: 8px;
          color: var(--text); font-family: var(--sans); font-size: 14px;
          resize: none; outline: none; line-height: 1.5;
          min-height: 44px; max-height: 120px;
          transition: border-color .15s;
        }
        .input-textarea:focus { border-color: var(--purple); }
        .input-textarea::placeholder { color: var(--muted); }
        .send-btn {
          padding: 0; background: var(--amber);
          border: none; border-radius: 10px; color: #1c1c2e;
          font-size: 20px; font-weight: 700;
          cursor: pointer; transition: all .15s; white-space: nowrap;
          height: 44px; width: 44px; flex-shrink: 0;
          display: flex; align-items: center; justify-content: center;
          box-shadow: 0 2px 8px rgba(201,168,76,.3);
        }
        .send-btn:hover:not(:disabled) { background: #d4a82a; transform: scale(1.05); }
        .send-btn:disabled { opacity: .4; cursor: not-allowed; transform: none; }
        .clear-btn {
          padding: 7px 16px; background: rgba(239,68,68,.08);
          border: 1px solid rgba(239,68,68,.35); border-radius: 6px;
          color: #f87171; font-family: var(--mono); font-size: 10px;
          cursor: pointer; transition: all .15s; letter-spacing: .06em; font-weight: 500;
        }
        .clear-btn:hover { background: rgba(239,68,68,.15); border-color: #ef4444; color: #fca5a5; }
        .clear-btn:disabled { opacity: .3; cursor: not-allowed; }

        .result-section-title {
          font-family: var(--mono); font-size: 9px; letter-spacing: .12em;
          text-transform: uppercase; color: #b8b5cc; margin-bottom: 8px; padding: 8px 12px 0;
        }
        .result-empty {
          padding: 24px; text-align: center; font-family: var(--mono);
          font-size: 11px; color: #b8b5cc; letter-spacing: .08em;
        }
        /* ── LOOKUP TAB ── */
        .lookup-container { flex: 1; overflow-y: auto; padding: 24px; color: var(--text); background: var(--bg); }
        .lookup-header { margin-bottom: 20px; }
        .lookup-header h2 { font-family: var(--serif); font-size: 22px; font-weight: 300; color: var(--text); margin-bottom: 4px; }
        .lookup-header p { font-family: var(--mono); font-size: 9px; color: var(--muted); letter-spacing: .08em; }

        .lookup-controls { display: flex; gap: 10px; margin-bottom: 16px; flex-wrap: wrap; }
        .lookup-select {
          padding: 8px 12px; background: var(--bg3);
          border: 1px solid var(--border2); border-radius: 4px;
          color: var(--text); font-family: var(--mono); font-size: 10px;
          outline: none; cursor: pointer; min-width: 160px;
        }
        .lookup-select:focus { border-color: var(--purple); }
        .lookup-input {
          flex: 1; padding: 8px 12px; background: var(--bg3);
          border: 1px solid var(--border2); border-radius: 4px;
          color: var(--text); font-family: var(--mono); font-size: 10px;
          outline: none; min-width: 200px;
        }
        .lookup-input:focus { border-color: var(--purple); }
        .lookup-input::placeholder { color: var(--muted); }
        .run-btn {
          padding: 8px 20px; background: var(--teal);
          border: none; border-radius: 4px; color: #000;
          font-family: var(--mono); font-size: 10px; font-weight: 600;
          cursor: pointer; letter-spacing: .06em; transition: opacity .15s;
          white-space: nowrap;
        }
        .run-btn:hover { opacity: .85; }
        .run-btn:disabled { opacity: .4; cursor: not-allowed; }

        .result-box {
          background: var(--bg2); border: 1px solid var(--border);
          border-radius: 6px; overflow: hidden;
        }
        .result-header {
          padding: 10px 16px; background: var(--bg3);
          border-bottom: 1px solid var(--border);
          font-family: var(--mono); font-size: 9px;
          color: #c0bdd8; letter-spacing: .08em;
          display: flex; align-items: center; justify-content: space-between;
        }
        .result-count { color: var(--teal); font-weight: 600; }
        .result-table { width: 100%; border-collapse: collapse; font-size: 12px; }
        .result-table th {
          background: var(--bg3); color: #f0dfa0;
          padding: 8px 12px; text-align: left;
          font-family: var(--mono); font-size: 8.5px;
          letter-spacing: .08em; text-transform: uppercase;
          border-bottom: 1px solid var(--border);
        }
        .result-table td { padding: 8px 12px; border-bottom: 1px solid var(--border); color: #f0eeff; }
        .result-table tr:last-child td { border-bottom: none; }
        .result-table tr:nth-child(even) td { background: rgba(255,255,255,.015); }
        .result-table td:first-child { font-family: var(--mono); font-size: 10px; color: var(--teal); }
        .result-json {
          padding: 16px; font-family: var(--mono); font-size: 11px;
          color: var(--text); overflow-x: auto; max-height: 500px;
          overflow-y: auto; line-height: 1.6; white-space: pre-wrap;
        }
      `}</style>

      <div className="app">
        {/* Topbar */}
        <div className="topbar">
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            {/* Sidebar toggle button */}
            <button onClick={() => setSidebarCollapsed(c => !c)}
              title={sidebarCollapsed ? "Show conversations" : "Hide conversations"}
              style={{background:"transparent",border:"1px solid #2a2a40",borderRadius:4,
                color:"var(--muted)",fontSize:13,cursor:"pointer",padding:"3px 7px",
                lineHeight:1,transition:"all .15s"}}
              onMouseOver={e=>{e.currentTarget.style.borderColor="#e4c97e";e.currentTarget.style.color="#e4c97e";}}
              onMouseOut={e=>{e.currentTarget.style.borderColor="#2a2a40";e.currentTarget.style.color="var(--muted)";}}>
              ☰
            </button>
            <img src={LOGO_WHITE} alt="STAR" style={{height:28,objectFit:"contain",
              filter: theme === "light" ? "invert(1) sepia(1) saturate(2) hue-rotate(185deg) brightness(0.3)" : "none"}} />
            <span style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)",letterSpacing:".06em"}}>API Intelligence</span>
          </div>
          {health && (
            <div className="stats">
              <span><strong>{domains.length || "—"}</strong> APIs</span>
            </div>
          )}
          {/* Version selector */}
          {versions.length > 0 && (
            <div style={{display:"flex",alignItems:"center",gap:6}}>
              <span style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--dim)",letterSpacing:".08em",textTransform:"uppercase"}}>Version</span>
              <select
                value={version}
                onChange={e => setVersion(e.target.value)}
                style={{
                  background:"#2a2d35", border:"1px solid rgba(201,168,76,.3)",
                  borderRadius:5, color:"#e4c97e", fontFamily:"var(--mono)",
                  fontSize:10, padding:"3px 8px", cursor:"pointer", outline:"none",
                }}
              >
                {versions.map(v => (
                  <option key={v.version} value={v.version}>
                    {v.display_label || v.version}{!v.display_label && v === versions[0] ? " (latest)" : ""}
                  </option>
                ))}
              </select>
              {(() => {
                const activeVersion = versions.find(v => v.version === version) || versions[0];
                if (!activeVersion) return null;
                const indexedDate = activeVersion.indexed_at
                  ? new Date(activeVersion.indexed_at).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })
                  : null;
                return (
                  <span
                    title={`Branch: ${activeVersion.branch}\nIndexed: ${indexedDate || "unknown"}`}
                    style={{
                      fontFamily:"var(--mono)", fontSize:9, color:"var(--dim)",
                      padding:"3px 8px", borderRadius:5, border:"1px solid #2a2a40",
                      cursor:"default", whiteSpace:"nowrap", overflow:"hidden",
                      textOverflow:"ellipsis", maxWidth:180,
                    }}
                  >
                    {activeVersion.display_label || activeVersion.branch}{indexedDate ? ` · ${indexedDate}` : ""}
                  </span>
                );
              })()}
            </div>
          )}
          <div style={{display:"flex",alignItems:"center",gap:16}}>
            <div className="aud-badge">
              <div className="status-dot" />
              <div className="aud-dot" style={{ background: aud.color }} />
              {aud.label}
            </div>
            <div style={{display:"flex",alignItems:"center",gap:8,marginLeft:"auto"}}>
              {/* Theme toggle */}
              <button
                onClick={() => setTheme(t => t === "dark" ? "light" : "dark")}
                title={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
                style={{
                  background: theme === "light" ? "#e0dcd8" : "transparent",
                  border: theme === "light" ? "1px solid #9a9888" : "1px solid var(--border2)",
                  borderRadius:4,
                  color: theme === "light" ? "#0a0a1a" : "var(--text)",
                  fontSize:15,cursor:"pointer",padding:"3px 8px",
                  lineHeight:1,transition:"all .15s",
                  boxShadow: theme === "light" ? "0 1px 3px rgba(0,0,0,.15)" : "none"}}>
                {theme === "dark" ? "☀️" : "🌙"}
              </button>
              <a href="https://star-standard-content.s3.amazonaws.com/star_intelligence_manual.html"
                target="_blank" rel="noopener noreferrer"
                style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".06em",
                  color:"#e4c97e",textDecoration:"none",padding:"4px 10px",
                  border:"1px solid rgba(201,168,76,.3)",borderRadius:4,transition:"all .2s"}}
                onMouseOver={e=>{e.currentTarget.style.borderColor="#c9a84c";e.currentTarget.style.background="rgba(201,168,76,.12)";}}
                onMouseOut={e=>{e.currentTarget.style.borderColor="rgba(201,168,76,.3)";e.currentTarget.style.background="transparent";}}
              >Help</a>
              <span style={{fontFamily:"var(--mono)",fontSize:9,color:"var(--muted)",paddingLeft:4,borderLeft:"1px solid #2a2a40",marginLeft:4}}>{userEmail}</span>
              <button onClick={handleLogout} style={{
                fontFamily:"var(--mono)",fontSize:9,letterSpacing:".06em",
                background:"transparent",border:"1px solid #2a2a40",borderRadius:4,
                color:"var(--dim)",padding:"4px 8px",cursor:"pointer"
              }}>Sign out</button>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="tabs">
          <button className={`tab-btn ${activeTab === "chat" ? "active" : ""}`} onClick={() => setActiveTab("chat")}>
            💬 Chat
          </button>
          <button className={`tab-btn ${activeTab === "lookup" ? "active" : ""}`} onClick={() => setActiveTab("lookup")}>
            📋 Quick Lookup
          </button>
          <button className={`tab-btn ${activeTab === "domains" ? "active" : ""}`} onClick={() => setActiveTab("domains")}>
            🗂️ API Explorer
          </button>
          <button className={`tab-btn ${activeTab === "compare" ? "active" : ""}`} onClick={() => setActiveTab("compare")}>
            ⚡ Compare Versions
          </button>
          {["pescobar@starstandard.org","steve@starstandard.org","digital.mqc@gmail.com"].includes(userEmail) && (
            <button className={`tab-btn ${activeTab === "usage" ? "active" : ""}`} onClick={() => setActiveTab("usage")}>
              📊 Usage
            </button>
          )}
        </div>

        {/* Main — left sidebar + content */}
        <div className="main">

          {/* ── LEFT HISTORY SIDEBAR ── */}
          <div className={`history-sidebar${sidebarCollapsed ? " collapsed" : ""}`}>
            <div className="history-sidebar-header">
              <span className="history-sidebar-title">
                {!sidebarCollapsed && "Conversations"}
              </span>
              <button className="history-toggle-btn"
                onClick={() => setSidebarCollapsed(c => !c)}
                title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}>
                {sidebarCollapsed ? "»" : "«"}
              </button>
            </div>
            {!sidebarCollapsed && (
              <>
                <button className="history-new-btn" onClick={startNewChat}>
                  ✏ New Chat
                </button>
                <div className="history-list">
                  {historyLoading ? (
                    <div style={{padding:"16px 14px",fontFamily:"var(--mono)",fontSize:10,color:"var(--muted)"}}>
                      Loading…
                    </div>
                  ) : conversations.length === 0 ? (
                    <div style={{padding:"16px 14px",fontFamily:"var(--mono)",fontSize:10,
                      color:"var(--muted)",lineHeight:1.6}}>
                      No conversations yet.<br/>Start chatting!
                    </div>
                  ) : conversations.map(conv => (
                    <div key={conv.id}
                      className={`history-item${currentConvId === conv.id ? " active" : ""}`}
                      onClick={() => loadConversation(conv.id)}>
                      <div className="history-item-body">
                        <div className="history-item-title">
                          {conv.title || "Untitled"}
                        </div>
                        <div className="history-item-meta">
                          <span>{new Date(conv.updated_at).toLocaleDateString(undefined,{month:"short",day:"numeric"})}</span>
                          <span>{conv.message_count} msgs</span>
                          {conv.version && conv.version !== "latest" && (
                            <span style={{color:"#e4c97e",opacity:.6}}>{conv.version}</span>
                          )}
                        </div>
                      </div>
                      <button className="history-item-del"
                        onClick={(e) => deleteConversation(conv.id, e)}
                        title="Delete">×</button>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>

          {/* ── CONTENT AREA ── */}
          <div className="content-area">

          {/* ── CHAT TAB ── */}
          {activeTab === "chat" && (
            <div className="chat-container">
              {/* Audience toggle */}
              <button className="aud-toggle" onClick={() => setShowAudience(v => !v)}>
                <span className={`aud-toggle-icon ${showAudience ? "open" : ""}`}>▶</span>
                {showAudience ? "Hide" : "Show"} role &amp; prompts
              </button>

              {showAudience && (
                <div className="aud-panel">
                  <div className="aud-section">
                    <h4>My Role <Tooltip text="Select your role to get responses tailored to your level of technical detail" position="right"><span style={{cursor:"help",color:"var(--muted)",fontSize:11,marginLeft:4}}>?</span></Tooltip></h4>
                    <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
                      <select
                        value={audience}
                        onChange={e => setAudience(e.target.value)}
                        style={{fontFamily:"var(--mono)",fontSize:11,
                          background:"var(--bg3)",color:"var(--text)",
                          border:"1px solid var(--border2)",borderRadius:6,
                          padding:"6px 12px",cursor:"pointer",minWidth:160}}>
                        {Object.entries(AUDIENCES).map(([key, a]) => (
                          <option key={key} value={key}>{a.icon} {a.label}</option>
                        ))}
                      </select>
                      <span style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--muted)"}}>
                        {AUDIENCES[audience]?.tooltip}
                      </span>
                    </div>
                  </div>
                  <div className="aud-section">
                    <h4>Quick prompts</h4>
                    <div className="qp-buttons">
                      {(QUICK_PROMPTS[audience] || []).map((qp, i) => (
                        <button key={i} className="qp-btn" onClick={() => handleQuickPrompt(qp)}>
                          {qp.label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Messages */}
              <div className="messages" ref={chatContainerRef} onScroll={handleMessagesScroll}>
                {/* Resume scrolling button — shown when user has scrolled up during streaming */}
                {messages.some(m => m.streaming) && userScrolledRef.current && (
                  <div style={{position:"sticky",top:8,zIndex:10,display:"flex",justifyContent:"center",pointerEvents:"none"}}>
                    <button
                      onClick={() => {
                        userScrolledRef.current = false;
                        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
                      }}
                      style={{pointerEvents:"all",fontFamily:"var(--mono)",fontSize:11,
                        background:"rgba(201,168,76,.9)",border:"none",borderRadius:20,
                        color:"#1c1c2e",padding:"5px 14px",cursor:"pointer",
                        boxShadow:"0 2px 8px rgba(0,0,0,.3)",fontWeight:600}}>
                      ↓ Resume scrolling
                    </button>
                  </div>
                )}
                {/* Jump to bottom button — sticky at top, shown when scrolled up > 300px */}
                {showScrollBottom && (
                  <button
                    className="back-to-bottom-btn"
                    onClick={() => {
                      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
                      setShowScrollBottom(false);
                    }}
                  >
                    ↓ Bottom
                  </button>
                )}
                {messages.length === 0 && !loading ? (
                  <div className="empty-state">
                    <div className="empty-glyph">STAR</div>
                    <div className="empty-title">API Intelligence Platform</div>
                    <div className="empty-hint">Ask anything about the STAR automotive APIs</div>
                    <div className="empty-badge" style={{ color: aud.color }}>
                      {aud.icon} Speaking to: {aud.label}
                    </div>
                    {/* Quick start hints */}
                    <div style={{marginTop:24,background:"rgba(201,168,76,.06)",border:"1px solid rgba(201,168,76,.15)",
                      borderRadius:10,padding:"16px 20px",maxWidth:480,textAlign:"left"}}>
                      <div style={{fontFamily:"var(--mono)",fontSize:9,letterSpacing:".12em",
                        textTransform:"uppercase",color:"var(--amber)",marginBottom:10}}>
                        💡 Try asking…
                      </div>
                      {[
                        "List all operations in repair_order",
                        "What does the RepairOrder schema look like?",
                        "Compare v1.1.0 vs v1.2.0 changes",
                        "Show me an example of a credit authorization request",
                        "What APIs are new in v1.2.0?",
                      ].map((q, i) => (
                        <div key={i}
                          onClick={() => { setInput(q); }}
                          style={{padding:"6px 10px",borderRadius:6,marginBottom:4,
                            fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)",
                            cursor:"pointer",transition:"all .15s",border:"1px solid transparent"}}
                          onMouseOver={e=>{e.currentTarget.style.background="rgba(201,168,76,.08)";e.currentTarget.style.borderColor="rgba(201,168,76,.2)";e.currentTarget.style.color="var(--text)";}}
                          onMouseOut={e=>{e.currentTarget.style.background="transparent";e.currentTarget.style.borderColor="transparent";e.currentTarget.style.color="var(--muted)";}}>
                          → {q}
                        </div>
                      ))}
                    </div>
                    <a href="https://star-standard-content.s3.amazonaws.com/star_intelligence_manual.html"
                      target="_blank" rel="noopener noreferrer"
                      style={{
                        display:"inline-flex", alignItems:"center", gap:8, marginTop:24,
                        padding:"10px 22px", borderRadius:8,
                        background:"rgba(201,168,76,.12)",
                        border:"1px solid rgba(201,168,76,.3)",
                        color:"#e4c97e", textDecoration:"none",
                        fontFamily:"var(--mono)", fontSize:11,
                        letterSpacing:".08em", textTransform:"uppercase",
                        transition:"all .2s",
                      }}
                      onMouseOver={e=>{e.currentTarget.style.background="rgba(201,168,76,.22)";e.currentTarget.style.borderColor="#c9a84c";}}
                      onMouseOut={e=>{e.currentTarget.style.background="rgba(201,168,76,.12)";e.currentTarget.style.borderColor="rgba(201,168,76,.3)";}}
                    >
                      📖 User Manual &amp; Help Guide
                    </a>
                  </div>
                ) : (
                  <>
                    {messages.map((msg, i) => (
                      <div key={i}>
                        {msg.role === "user" ? (
                          <div className="msg-user">
                            <div className="msg-user-inner">
                              <div className="msg-user-bubble">{msg.text}</div>
                              <div className="msg-meta msg-meta-right">
                                <span className="msg-aud-tag" style={{ color: AUDIENCES[msg.audience]?.color }}>
                                  {AUDIENCES[msg.audience]?.icon} {AUDIENCES[msg.audience]?.label}
                                </span>
                                <span>{formatTime(msg.time)}</span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="msg-ai">
                            <div className="msg-ai-avatar">◈</div>
                            <div className="msg-ai-body">
                              <div
                                className="msg-ai-content"
                                dangerouslySetInnerHTML={{ __html: renderMarkdown(msg.text) + (msg.streaming ? '<span class="stream-cursor">▋</span>' : '') }}
                              />
                              {!msg.streaming && (
                              <div className="msg-meta">
                                {msg.audience && (
                                  <>
                                    <span className="msg-aud-tag" style={{ color: AUDIENCES[msg.audience]?.color }}>
                                      {AUDIENCES[msg.audience]?.icon} {AUDIENCES[msg.audience]?.label}
                                    </span>
                                    <span>·</span>
                                  </>
                                )}
                                <span>{msg.chunks} chunks</span>
                                <span>·</span>
                                <span>{formatTime(msg.time)}</span>
                                <span>·</span>
                                {/* Copy button */}
                                <button
                                  onClick={() => {
                                    navigator.clipboard.writeText(msg.text).then(() => {
                                      const btn = document.getElementById(`copy-btn-${i}`);
                                      if (btn) { btn.textContent = "✓ Copied"; setTimeout(() => { btn.textContent = "⎘ Copy"; }, 1500); }
                                    });
                                  }}
                                  id={`copy-btn-${i}`}
                                  style={{background:"transparent",border:"none",cursor:"pointer",
                                    fontFamily:"var(--mono)",fontSize:11,color:"var(--dim)",
                                    padding:"0 4px",letterSpacing:".06em",transition:"color .2s"}}
                                  onMouseOver={e=>e.target.style.color="var(--amber)"}
                                  onMouseOut={e=>e.target.style.color="var(--dim)"}
                                >Copy</button>
                                {/* Download response */}
                                <DownloadButton
                                  getText={() => msg.text}
                                  baseName={`star_response_${formatTime(msg.time).replace(/[: ]/g,"_")}`}
                                  label="Download"
                                  style={{display:"inline-flex"}}
                                />
                              </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                    {loading && (
                      <div className="msg-ai">
                        <div className="msg-ai-avatar">◈</div>
                        <div className="loading-dots">
                          <div className="loading-dot" />
                          <div className="loading-dot" />
                          <div className="loading-dot" />
                        </div>
                      </div>
                    )}
                    <div ref={messagesEndRef} />
                  </>
                )}
                {/* Back to top button — sticky inside the scroll container */}
                {showScrollTop && (
                  <button
                    className="back-to-top-btn"
                    onClick={() => {
                      chatContainerRef.current?.scrollTo({ top: 0, behavior: "smooth" });
                      setShowScrollTop(false);
                    }}
                  >
                    ↑ Top
                  </button>
                )}
              </div>

              {/* Input bar */}
              <div className="input-bar">
                <div className="input-hint">{aud.icon} {aud.label} · {aud.hint}</div>
                <div className="input-selects">
                  <select
                    className="input-select"
                    value={domain}
                    onChange={e => setDomain(e.target.value)}
                  >
                    <option value="">(all APIs)</option>
                    {domains.map(d => (
                      <option key={d.domain} value={d.domain}>{d.domain}</option>
                    ))}
                  </select>
                  <button
                    className="clear-btn"
                    onClick={() => { setMessages([]); setCurrentConvId(null); currentConvIdRef.current = null; }}
                    disabled={messages.length === 0}
                    style={{ opacity: messages.length === 0 ? 0.3 : 1 }}
                  >
                    Clear chat
                  </button>
                  {/* XML5 toggle */}
                  <button
                    onClick={() => setIncludeXml5(x => !x)}
                    title={includeXml5 ? "XML5 context ON — click to disable" : "Enable XML5 BOD context for gap analysis"}
                    style={{
                      fontFamily:"var(--mono)", fontSize:9, letterSpacing:".06em",
                      padding:"4px 8px", borderRadius:4, cursor:"pointer",
                      border: includeXml5 ? "1px solid #f59e0b" : "1px solid var(--border2)",
                      background: includeXml5 ? "rgba(245,158,11,.15)" : "transparent",
                      color: includeXml5 ? "#f59e0b" : "var(--dim)",
                      transition:"all .15s",
                    }}>
                    {includeXml5 ? "⚡ XML5 ON" : "XML5"}
                  </button>
                  {messages.length > 0 && (
                    <DownloadButton
                      getText={() => {
                        const aud = AUDIENCES[audience];
                        let md = `# STAR API Intelligence — Session Export\n`;
                        md += `**Role:** ${aud?.label || "Assistant"} · **Version:** ${version} · **Date:** ${new Date().toLocaleString()}\n\n---\n\n`;
                        messages.forEach((msg) => {
                          if (msg.role === "user") {
                            md += `## 💬 Question\n${msg.text}\n\n`;
                          } else {
                            md += `## ◈ Response`;
                            if (msg.chunks) md += ` _(${msg.chunks} chunks)_`;
                            md += `\n${msg.text}\n\n---\n\n`;
                          }
                        });
                        return md;
                      }}
                      baseName={`star_session_${new Date().toISOString().slice(0,10)}`}
                      label="Download session"
                    />
                  )}
                </div>
                <div className="input-row">
                  <textarea
                    ref={inputRef}
                    className="input-textarea"
                    value={input}
                    onChange={e => setInput(e.target.value)}
                    onKeyDown={e => {
                      if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        sendQuery(input, null);
                      }
                    }}
                    placeholder={aud.hint}
                    rows={1}
                  />
                  <button
                    className="send-btn"
                    disabled={!input.trim() || loading}
                    onClick={() => sendQuery(input, null)}
                    title="Send message"
                  >
                    ↑
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* ── LOOKUP TAB ── */}
          {/* Keep LookupTab mounted but hidden to preserve state when switching tabs */}
          <div style={{display: activeTab === "lookup" ? "flex" : "none", flex:1, overflow:"hidden", flexDirection:"column"}}>
            <LookupTab domains={domains} apiUrl={API_URL} authHeaders={authHeaders} version={version} />
          </div>
          {activeTab === "domains" && (
            <DomainExplorerTab apiUrl={API_URL} authHeaders={authHeaders} version={version} />
          )}
          {activeTab === "compare" && (
            <CompareTab
              versions={versions}
              domains={domains}
              apiUrl={API_URL}
              authHeaders={authHeaders}
            />
          )}
          {activeTab === "usage" && (
            <UsageTab apiUrl={API_URL} authHeaders={authHeaders} />
          )}
        </div>
        {/* End content-area */}
        </div>
      </div>
    </>
  );
}
